export const inventoryData = [
    {
        "KORNAME": "붕사",
        "IUPACNAME": "sodium tetraborate decahydrate",
        "TRINAME": "borax",
        "LOCATION": "1-1 하",
        "MOL_FORMULA": "Na2B4O7·10H2O",
        "MOL_MASS": "201.22 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 5.0
    },
    {
        "KORNAME": "만능 지시약",
        "IUPACNAME": "Universal Indicator",
        "TRINAME": "Universal Indicator",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "칼슘바이트",
        "IUPACNAME": "Calcium acetylide",
        "TRINAME": "calcium carbide",
        "LOCATION": "1-1 상",
        "MOL_FORMULA": "CaC2",
        "MOL_MASS": "64.099 g/mol",
        "NFPA_R": 4.0,
        "NFPA_Y": 2.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "설파믹산 암모늄",
        "IUPACNAME": "Ammonium sulfamate",
        "TRINAME": "ammonium sulfamate",
        "LOCATION": "1-1 하",
        "MOL_FORMULA": "[NH4]SO3NH2",
        "MOL_MASS": "114.125 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "탄산 칼슘",
        "IUPACNAME": "Calcium carbonate",
        "TRINAME": "Calcium carbonate",
        "LOCATION": "1-1 상",
        "MOL_FORMULA": "CaCO3",
        "MOL_MASS": "100.0869 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "벤조산",
        "IUPACNAME": "Benzoic acid",
        "TRINAME": "Benzoic acid",
        "LOCATION": "1-1 하",
        "MOL_FORMULA": "C7H6O2",
        "MOL_MASS": "122.123 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 3.0
    },
    {
        "KORNAME": "염화칼슘",
        "IUPACNAME": "Calcium chloride",
        "TRINAME": "Calcium chloride",
        "LOCATION": "1-3 하",
        "MOL_FORMULA": "CaCl2",
        "MOL_MASS": "110.98 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "카페인",
        "IUPACNAME": "caffeine anhydrous",
        "TRINAME": "caffeine anhydrous",
        "LOCATION": "1-1상",
        "MOL_FORMULA": "CaH10N4O2",
        "MOL_MASS": 194.19,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "무수 아세트산",
        "IUPACNAME": "Acetic anhydride",
        "TRINAME": "Ethanoic anhydride",
        "LOCATION": "1-1하",
        "MOL_FORMULA": "C4H6O3",
        "MOL_MASS": "102.089 g·mol−1",
        "NFPA_R": 2.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 3.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 5.0
    },
    {
        "KORNAME": "아세톤",
        "IUPACNAME": "Acetone",
        "TRINAME": "acetone",
        "LOCATION": "1-1하",
        "MOL_FORMULA": "C3H6O",
        "MOL_MASS": "58.080 g·mol−1",
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "아세트산 에틸",
        "IUPACNAME": "Ethyl acetate",
        "TRINAME": "Ethyl ethanoate",
        "LOCATION": "1-1하",
        "MOL_FORMULA": "C4H8O2",
        "MOL_MASS": "88.106 g·mol−1",
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "에틸 에테르",
        "IUPACNAME": "ethyl aether",
        "TRINAME": "ethyl aether",
        "LOCATION": "1-2상",
        "MOL_FORMULA": "C2H5OC2H5",
        "MOL_MASS": 74.12,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "아이소프로필 알코올",
        "IUPACNAME": "Propan-2-ol",
        "TRINAME": "Isopropyl alcohol",
        "LOCATION": "1-1상",
        "MOL_FORMULA": "C3H8O",
        "MOL_MASS": "60.096 g/mol",
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "벤자인 알코올",
        "IUPACNAME": "Phenylmethanol",
        "TRINAME": "benzene",
        "LOCATION": "1-1하",
        "MOL_FORMULA": "C6H5CH2OH",
        "MOL_MASS": "108.140 g·mol−1",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "보릭산",
        "IUPACNAME": "Boric acid",
        "TRINAME": "Boric acid",
        "LOCATION": "1-1하",
        "MOL_FORMULA": "H3BO3",
        "MOL_MASS": "61.83 g·mol−1",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "세라이트545(규조토)",
        "IUPACNAME": "Calcinated diatomaceous earth",
        "TRINAME": "Celite",
        "LOCATION": "1-1상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "활성탄",
        "IUPACNAME": "Activated carbon",
        "TRINAME": "Activated carbon",
        "LOCATION": "1-1상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 6.0
    },
    {
        "KORNAME": "활성숯",
        "IUPACNAME": "Activated charcoal",
        "TRINAME": "Activated charcoal",
        "LOCATION": "1-1상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "염화칼륨용액",
        "IUPACNAME": "potassium chloride solution",
        "TRINAME": "Muriate of potash",
        "LOCATION": "1-1하",
        "MOL_FORMULA": "KCl",
        "MOL_MASS": "74.555 g·mol−1",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산바륨",
        "IUPACNAME": "Barium nitrate",
        "TRINAME": "Barium nitrate",
        "LOCATION": "1-1하",
        "MOL_FORMULA": "Ba(NO3)2",
        "MOL_MASS": "261.337 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 3.0,
        "NFPA_B": 3.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 3.0
    },
    {
        "KORNAME": "디부틸히드록시톨루엔",
        "IUPACNAME": "2,6-Di-tert-butyl-4-methylphenol",
        "TRINAME": "Butylated hydroxytoluene",
        "LOCATION": "1-1하",
        "MOL_FORMULA": "C15H24O",
        "MOL_MASS": "220.356 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "카본 블랙",
        "IUPACNAME": "carbon, mesoporous",
        "TRINAME": "carbon, mesoporous",
        "LOCATION": "1-1상",
        "MOL_FORMULA": "C",
        "MOL_MASS": "12.01 mol/g",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 2.0
    },
    {
        "KORNAME": "백반 용액",
        "IUPACNAME": "_x0008_alum solution",
        "TRINAME": "_x0008_alum solution",
        "LOCATION": "1-1하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "브로민화 세트리모늄",
        "IUPACNAME": "hexadecyl(trimethyl)ammonium bromide",
        "TRINAME": "cetyltrimethylammonium bromide",
        "LOCATION": "1-1상",
        "MOL_FORMULA": "C19H42BrN",
        "MOL_MASS": "364.45 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "탄소 가루",
        "IUPACNAME": "carbon powder",
        "TRINAME": "carbon powder",
        "LOCATION": "1-1상",
        "MOL_FORMULA": "C",
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 2.0
    },
    {
        "KORNAME": "브로민화 칼륨",
        "IUPACNAME": "_x0008_kbr powder",
        "TRINAME": "kbr powder",
        "LOCATION": "1-1하",
        "MOL_FORMULA": "KBr",
        "MOL_MASS": "119.002 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "BTB용액",
        "IUPACNAME": "bromothymol blue",
        "TRINAME": "bromothymol blue",
        "LOCATION": "1-1하",
        "MOL_FORMULA": "C27H28Br2O5S",
        "MOL_MASS": "624.38 g·mol−1",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "디에틸 에테르",
        "IUPACNAME": "Diethyl Ether",
        "TRINAME": "Diethyl Ether",
        "LOCATION": "1-2상",
        "MOL_FORMULA": "C2H5OC2H5",
        "MOL_MASS": "74.12 g/mol",
        "NFPA_R": 4,
        "NFPA_Y": 1,
        "NFPA_B": 2,
        "NFPA_W": "x",
        "CAS number": "60-29-7",
        "퍼센트": NaN,
        "COUNT": 1,
        "Unnamed: 13": NaN,
        "Unnamed: 14": NaN,
        "Unnamed: 15": "INSERT INTO reagent (KORNAME, IUPACNAME, TRINAME, LOCATION, MOL_FORMULA, MOL_MASS, NFPA_R, NFPA_Y, NFPA_B, NFPA_W, CAS_number, percent, COUNT, location_room) VALUES ('디에틸 에테르', 'Diethyl Ether', 'Diethyl Ether', '1-2상', 'C2H5OC2H5', 74.12 , 4, 1, 2, 'x', '60-29-7', NULL, 1, '화학')"
    },
    {
        "KORNAME": "EDTA",
        "IUPACNAME": "Ethylene Diamine Tetraacetic Acids",
        "TRINAME": "EDTA",
        "LOCATION": "1-2상",
        "MOL_FORMULA": "C10H16N2O8",
        "MOL_MASS": "292.25 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 1,
        "NFPA_W": "x",
        "CAS number": "60-00-4",
        "퍼센트": 0.99,
        "COUNT": 2,
        "Unnamed: 13": 2.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('EDTA', 'Ethylene Diamine Tetraacetic Acids', 'EDTA', '1-2상', 'C10H16N2O8', 292.25 , 0, 0, 1, 'x', '60-00-4', 0.99, 2, '화학')"
    },
    {
        "KORNAME": "EDTA-2Na 2수화물",
        "IUPACNAME": "Ethylene Diamine Tetraacetic Acids",
        "TRINAME": "EDTA-2Na",
        "LOCATION": "1-2상",
        "MOL_FORMULA": "C10H14N2O8Na2·2H2O",
        "MOL_MASS": "372.24 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 1,
        "NFPA_W": "x",
        "CAS number": "6381-92-6",
        "퍼센트": 0.99,
        "COUNT": 1,
        "Unnamed: 13": 1.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('EDTA-2Na 2수화물', 'Ethylene Diamine Tetraacetic Acids', 'EDTA-2Na', '1-2상', 'C10H14N2O8Na2·2H2O', 372.24 , 0, 0, 1, 'x', '6381-92-6', 0.99, 1, '화학')"
    },
    {
        "KORNAME": "아세트산 에틸",
        "IUPACNAME": "Ethyl Acetate",
        "TRINAME": "Ethyl Acetate",
        "LOCATION": "1-2상",
        "MOL_FORMULA": "CH3COOC2H5",
        "MOL_MASS": "88.11 g/mol",
        "NFPA_R": 3,
        "NFPA_Y": 0,
        "NFPA_B": 1,
        "NFPA_W": "x",
        "CAS number": "141-78-6",
        "퍼센트": 0.995,
        "COUNT": 4,
        "Unnamed: 13": 4.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('아세트산 에틸', 'Ethyl Acetate', 'Ethyl Acetate', '1-2상', 'CH3COOC2H5', 88.11 , 3, 0, 1, 'x', '141-78-6', 0.995, 4, '화학')"
    },
    {
        "KORNAME": "아세트산 에틸",
        "IUPACNAME": "Ethyl Acetate",
        "TRINAME": "Ethyl Acetate",
        "LOCATION": "1-2상",
        "MOL_FORMULA": "CH3COOC2H5",
        "MOL_MASS": "88.11 g/mol",
        "NFPA_R": 3,
        "NFPA_Y": 0,
        "NFPA_B": 1,
        "NFPA_W": "x",
        "CAS number": "141-78-6",
        "퍼센트": 0.99,
        "COUNT": 2,
        "Unnamed: 13": 2.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('아세트산 에틸', 'Ethyl Acetate', 'Ethyl Acetate', '1-2상', 'CH3COOC2H5', 88.11 , 3, 0, 1, 'x', '141-78-6', 0.99, 2, '화학')"
    },
    {
        "KORNAME": "아세트산 에틸",
        "IUPACNAME": "Ethyl Acetate",
        "TRINAME": "Ethyl Acetate",
        "LOCATION": "1-2상",
        "MOL_FORMULA": "CH3COOC2H5",
        "MOL_MASS": "88.11 g/mol",
        "NFPA_R": 3,
        "NFPA_Y": 0,
        "NFPA_B": 1,
        "NFPA_W": "x",
        "CAS number": "141-78-6",
        "퍼센트": 0.95,
        "COUNT": 4,
        "Unnamed: 13": 4.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('아세트산 에틸', 'Ethyl Acetate', 'Ethyl Acetate', '1-2상', 'CH3COOC2H5', 88.11 , 3, 0, 1, 'x', '141-78-6', 0.95, 4, '화학')"
    },
    {
        "KORNAME": "에틸 에테르",
        "IUPACNAME": "Ethyl Ether",
        "TRINAME": "Ethyl Ether",
        "LOCATION": "1-2상",
        "MOL_FORMULA": "(CH3CH2)2O",
        "MOL_MASS": "74.12 g/mol",
        "NFPA_R": 4,
        "NFPA_Y": 1,
        "NFPA_B": 2,
        "NFPA_W": "x",
        "CAS number": "141-78-6",
        "퍼센트": 0.99,
        "COUNT": 4,
        "Unnamed: 13": 3.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('에틸 에테르', 'Ethyl Ether', 'Ethyl Ether', '1-2상', '(CH3CH2)2O', 74.12 , 4, 1, 2, 'x', '141-78-6', 0.99, 4, '화학')"
    },
    {
        "KORNAME": "염화 알루미늄 무수물",
        "IUPACNAME": "Aluminium Chloride anhydrous",
        "TRINAME": "Aluminium Chloride anhydrous",
        "LOCATION": "1-2하",
        "MOL_FORMULA": "AlCl3",
        "MOL_MASS": "133.34 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 2,
        "NFPA_B": 3,
        "NFPA_W": "x",
        "CAS number": "7446-70-0",
        "퍼센트": 0.98,
        "COUNT": 1,
        "Unnamed: 13": 1.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('염화 알루미늄 무수물', 'Aluminium Chloride anhydrous', 'Aluminium Chloride anhydrous', '1-2하', 'AlCl3', 133.34 , 0, 2, 3, 'x', '7446-70-0', 0.98, 1, '화학')"
    },
    {
        "KORNAME": "수산화 알루미늄",
        "IUPACNAME": "Aluminium Hydroxide",
        "TRINAME": "Aluminium Hydroxide",
        "LOCATION": "1-2하",
        "MOL_FORMULA": "Al(OH)3",
        "MOL_MASS": "78 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 1,
        "NFPA_W": "x",
        "CAS number": "21645-51-2",
        "퍼센트": 1.0,
        "COUNT": 1,
        "Unnamed: 13": 1.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('수산화 알루미늄', 'Aluminium Hydroxide', 'Aluminium Hydroxide', '1-2하', 'Al(OH)3', 78 , 0, 0, 1, 'x', '21645-51-2', 1, 1, '화학')"
    },
    {
        "KORNAME": "질산 알루미늄 9수화물",
        "IUPACNAME": "Aluminium Nitrate Enneahydrate",
        "TRINAME": "Aluminium Nitrate Nonahydrate",
        "LOCATION": "1-2하",
        "MOL_FORMULA": "Al(NO3)3. 9H2O",
        "MOL_MASS": "375.13 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "x",
        "CAS number": "7784-27-2",
        "퍼센트": 0.98,
        "COUNT": 1,
        "Unnamed: 13": 1.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('질산 알루미늄 9수화물', 'Aluminium Nitrate Enneahydrate', 'Aluminium Nitrate Nonahydrate', '1-2하', 'Al(NO3)3. 9H2O', 375.13 , 0, 0, 2, 'x', '7784-27-2', 0.98, 1, '화학')"
    },
    {
        "KORNAME": "황산 칼륨 알루미늄 12수화물",
        "IUPACNAME": "Aluminium Potassium Sulfate Dodecahydrate",
        "TRINAME": "Aluminium Potassium Sulfate Dodecahydrate",
        "LOCATION": "1-2하",
        "MOL_FORMULA": "AlK(SO4)2·12H2O",
        "MOL_MASS": "474.39 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "x",
        "CAS number": "7784-24-9",
        "퍼센트": 0.99,
        "COUNT": 4,
        "Unnamed: 13": 4.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('황산 칼륨 알루미늄 12수화물', 'Aluminium Potassium Sulfate Dodecahydrate', 'Aluminium Potassium Sulfate Dodecahydrate', '1-2하', 'AlK(SO4)2·12H2O', 474.39 , 0, 0, 2, 'x', '7784-24-9', 0.99, 4, '화학')"
    },
    {
        "KORNAME": "염화 암모늄",
        "IUPACNAME": "Ammonium Chloride",
        "TRINAME": "Ammonium Chloride",
        "LOCATION": "1-2하",
        "MOL_FORMULA": "NH4Cl",
        "MOL_MASS": "53.49 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "x",
        "CAS number": null,
        "퍼센트": 0.99,
        "COUNT": 5,
        "Unnamed: 13": 5.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('염화 암모늄', 'Ammonium Chloride', 'Ammonium Chloride', '1-2하', 'NH4Cl', 53.49 , 0, 0, 2, 'x', '3734646', 0.99, 5, '화학')"
    },
    {
        "KORNAME": "염화 암모늄",
        "IUPACNAME": "Ammonium Chloride",
        "TRINAME": "Ammonium Chloride",
        "LOCATION": "1-2하",
        "MOL_FORMULA": "NH4Cl",
        "MOL_MASS": "53.5 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "x",
        "CAS number": null,
        "퍼센트": 0.985,
        "COUNT": 1,
        "Unnamed: 13": 1.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('염화 암모늄', 'Ammonium Chloride', 'Ammonium Chloride', '1-2하', 'NH4Cl', 53.5 , 0, 0, 2, 'x', '3734646', 0.985, 1, '화학')"
    },
    {
        "KORNAME": "2염기성 시트르산 암모늄",
        "IUPACNAME": "Ammonium Citrate Dibasic",
        "TRINAME": "Ammonium Citrate Dibasic",
        "LOCATION": "1-2하",
        "MOL_FORMULA": "HOC(COOH)(CH2COONH4)2",
        "MOL_MASS": "226.19 g/mol",
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "x",
        "CAS number": "3111-72-8",
        "퍼센트": 1.0,
        "COUNT": 2,
        "Unnamed: 13": 2.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('2염기성 시트르산 암모늄', 'Ammonium Citrate Dibasic', 'Ammonium Citrate Dibasic', '1-2하', 'HOC(COOH)(CH2COONH4)2', 226.19 , 1, 0, 2, 'x', '3111-72-8', 1, 2, '화학')"
    },
    {
        "KORNAME": "황산 (제1)철 암모늄 6수화물",
        "IUPACNAME": "Ammonium Iron(II) Sulfate Hexahydrate",
        "TRINAME": "Ammonium Iron(II) Sulfate Hexahydrate",
        "LOCATION": "1-2하",
        "MOL_FORMULA": "(NH4)2Fe(SO4)2.6H2O",
        "MOL_MASS": "392.14 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "x",
        "CAS number": "7783-83-7",
        "퍼센트": 0.99,
        "COUNT": 1,
        "Unnamed: 13": 1.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('황산 (제1)철 암모늄 6수화물', 'Ammonium Iron(II) Sulfate Hexahydrate', 'Ammonium Iron(II) Sulfate Hexahydrate', '1-2하', '(NH4)2Fe(SO4)2.6H2O', 392.14 , 0, 0, 2, 'x', '7783-83-7', 0.99, 1, '화학')"
    },
    {
        "KORNAME": "구연산 (제2)철 암모늄",
        "IUPACNAME": "Ammonium Iron(III) Citrate",
        "TRINAME": "Ammonium Iron(III) Citrate",
        "LOCATION": "1-2하",
        "MOL_FORMULA": "C6H8O7·xFe3+·yNH3",
        "MOL_MASS": "392.14 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "x",
        "CAS number": "1336-77-6",
        "퍼센트": 0.95,
        "COUNT": 1,
        "Unnamed: 13": 1.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('구연산 (제2)철 암모늄', 'Ammonium Iron(III) Citrate', 'Ammonium Iron(III) Citrate', '1-2하', 'C6H8O7·xFe3+·yNH3', 392.14 , 0, 0, 2, 'x', '1336-77-6', 0.95, 1, '화학')"
    },
    {
        "KORNAME": "몰리브덴산 암모늄 4수화물",
        "IUPACNAME": "Ammonium Molybdate Tetrahydrate",
        "TRINAME": "Ammonium Molybdate Tetrahydrate",
        "LOCATION": "1-2하",
        "MOL_FORMULA": "(NH4)6Mo7O24 · 4H2O",
        "MOL_MASS": "1235.86 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "x",
        "CAS number": "12054-85-2",
        "퍼센트": 0.98,
        "COUNT": 1,
        "Unnamed: 13": 1.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('몰리브덴산 암모늄 4수화물', 'Ammonium Molybdate Tetrahydrate', 'Ammonium Molybdate Tetrahydrate', '1-2하', '(NH4)6Mo7O24 · 4H2O', 1235.86 , 0, 0, 2, 'x', '12054-85-2', 0.98, 1, '화학')"
    },
    {
        "KORNAME": "수산암모늄 1수화물",
        "IUPACNAME": "Ammonium Oxalate, Monohydrate",
        "TRINAME": "Ammonium Oxalate, Monohydrate",
        "LOCATION": "1-2하",
        "MOL_FORMULA": "(NH4)2C2O4. H2O",
        "MOL_MASS": "142.11 g/mol",
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "x",
        "CAS number": "1185-57-5",
        "퍼센트": 0.99,
        "COUNT": 1,
        "Unnamed: 13": 1.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('수산암모늄 1수화물', 'Ammonium Oxalate, Monohydrate', 'Ammonium Oxalate, Monohydrate', '1-2하', '(NH4)2C2O4. H2O', 142.11 , 1, 0, 2, 'x', '1185-57-5', 0.99, 1, '화학')"
    },
    {
        "KORNAME": "과황산 암모늄",
        "IUPACNAME": "Ammonium Persulfate",
        "TRINAME": "Ammonium Persulfate",
        "LOCATION": "1-2하",
        "MOL_FORMULA": "(NH4)2S2O8",
        "MOL_MASS": "228.19 g/mol",
        "NFPA_R": 1,
        "NFPA_Y": 2,
        "NFPA_B": 2,
        "NFPA_W": "OX",
        "CAS number": "7727-54-0",
        "퍼센트": 0.95,
        "COUNT": 1,
        "Unnamed: 13": 1.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('과황산 암모늄', 'Ammonium Persulfate', 'Ammonium Persulfate', '1-2하', '(NH4)2S2O8', 228.19 , 1, 2, 2, 'OX', '7727-54-0', 0.95, 1, '화학')"
    },
    {
        "KORNAME": "1염기성 인산 암모늄",
        "IUPACNAME": "Ammonium Phosphate Monobasic",
        "TRINAME": "Ammonium Phosphate Monobasic",
        "LOCATION": "1-2하",
        "MOL_FORMULA": "NH4H2PO4",
        "MOL_MASS": "115.03 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "x",
        "CAS number": "7722-76-1",
        "퍼센트": 0.98,
        "COUNT": 7,
        "Unnamed: 13": 7.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('1염기성 인산 암모늄', 'Ammonium Phosphate Monobasic', 'Ammonium Phosphate Monobasic', '1-2하', 'NH4H2PO4', 115.03 , 0, 0, 2, 'x', '7722-76-1', 0.98, 7, '화학')"
    },
    {
        "KORNAME": "황산 구리 5수화물",
        "IUPACNAME": "Copper(II) sulfate pentahydrate",
        "TRINAME": "Copper(2) sulfate pentahydrate",
        "LOCATION": "1-2하",
        "MOL_FORMULA": "CuSO4.5H2O",
        "MOL_MASS": "249.69 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 1,
        "NFPA_B": 2,
        "NFPA_W": "x",
        "CAS number": "7758-99-8",
        "퍼센트": 0.99,
        "COUNT": 2,
        "Unnamed: 13": 2.0,
        "Unnamed: 14": NaN,
        "Unnamed: 15": ", ('황산 구리 5수화물', 'Copper(II) sulfate pentahydrate', 'Copper(2) sulfate pentahydrate', '1-2하', 'CuSO4.5H2O', 249.69 , 0, 1, 2, 'x', '7758-99-8', 0.99, 2, '화학')"
    },
    {
        "KORNAME": "플루오르화 칼슘",
        "IUPACNAME": "calcium fluoride",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "CaF_2",
        "MOL_MASS": "78.075 g·mol−1",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": "-",
        "CAS number": "7789-75-5",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산구리",
        "IUPACNAME": "Copper(II) nitrate trihydrate",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "Cu(NO_3)_2",
        "MOL_MASS": "241.60 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 3.0,
        "NFPA_B": 1.0,
        "NFPA_W": "OX",
        "CAS number": "10031-43-3",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Cooper(I) chloride, 93.0%",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "황산 나트륨",
        "IUPACNAME": "Sodium sulfite anhydrous",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "Na_2SO_4",
        "MOL_MASS": "142.04 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "7757-82-6",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Calcium oxide",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "CaO",
        "MOL_MASS": "56.0774 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 2.0,
        "NFPA_B": 3.0,
        "NFPA_W": "W",
        "CAS number": "1305-78-8",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화 구리",
        "IUPACNAME": "Copper(II) chloride dihydrate",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "CuCl2",
        "MOL_MASS": "170.48 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": "-",
        "CAS number": "10125-13-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "구리표준용액",
        "IUPACNAME": "Copper standard solution",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화 구리",
        "IUPACNAME": "Copper(II) chloride dihydrate",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "CuCl2",
        "MOL_MASS": "170.48 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": "-",
        "CAS number": "10125-13-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "아세트산 칼슘",
        "IUPACNAME": "Calcium acetate",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "사이클로헥산올",
        "IUPACNAME": "Cyclohexanone",
        "TRINAME": "Cyclohexanol",
        "LOCATION": "하",
        "MOL_FORMULA": "C_6H_12O",
        "MOL_MASS": "100.158 g/mol",
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "108-93-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화 구리",
        "IUPACNAME": "Copper(II) chloride dihydrate",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "CuCl2",
        "MOL_MASS": "170.48 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": "-",
        "CAS number": "10125-13-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "아세트산 구리",
        "IUPACNAME": "Copper(II) acetate monohydrate",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "Cu(CH_3COO)_2",
        "MOL_MASS": "199.65 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": "-",
        "CAS number": "6046-93-1",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화 구리",
        "IUPACNAME": "Copper(II) chloride dihydrate",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "CuCl2",
        "MOL_MASS": "170.48 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": "-",
        "CAS number": "10125-13-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "수산화 칼슘",
        "IUPACNAME": "Calcium hydroxide",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "Ca(OH)_2",
        "MOL_MASS": "74.093 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 3.0,
        "NFPA_W": "-",
        "CAS number": "1305-62-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화 구리",
        "IUPACNAME": "Copper(II) chloride dihydrate",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "CuCl2",
        "MOL_MASS": "170.48 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": "-",
        "CAS number": "10125-13-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화 바륨",
        "IUPACNAME": "Barium chloride",
        "TRINAME": null,
        "LOCATION": "상",
        "MOL_FORMULA": "BaCl_2",
        "MOL_MASS": "208.23 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 3.0,
        "NFPA_W": "-",
        "CAS number": "10361-37-2",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화 칼슘",
        "IUPACNAME": "Calcium chloride, anhydrous",
        "TRINAME": null,
        "LOCATION": "상",
        "MOL_FORMULA": "CaCl_2",
        "MOL_MASS": "110.98 g·mol−1",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": "-",
        "CAS number": "10043-52-4",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화 구리",
        "IUPACNAME": "Copper(II) chloride dihydrate",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "CuCl2",
        "MOL_MASS": "170.48 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": "-",
        "CAS number": "10125-13-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Copper standard solution",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "수산화 칼슘",
        "IUPACNAME": "Calcium hydroxide",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "Ca(OH)_2",
        "MOL_MASS": "74.093 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 3.0,
        "NFPA_W": "-",
        "CAS number": "1305-62-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화 바륨",
        "IUPACNAME": "Barium chloride",
        "TRINAME": null,
        "LOCATION": "상",
        "MOL_FORMULA": "BaCl_2",
        "MOL_MASS": "208.23 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 3.0,
        "NFPA_W": "-",
        "CAS number": "10361-37-2",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "수산화 칼슘",
        "IUPACNAME": "Calcium hydroxide",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "Ca(OH)_2",
        "MOL_MASS": "74.093 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 3.0,
        "NFPA_W": "-",
        "CAS number": "1305-62-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "아세트산 바륨",
        "IUPACNAME": "Barium acetate",
        "TRINAME": null,
        "LOCATION": "상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화 구리",
        "IUPACNAME": "Copper(II) chloride dihydrate",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "CuCl2",
        "MOL_MASS": "170.48 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": "-",
        "CAS number": "10125-13-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산구리",
        "IUPACNAME": "Copper(II) nitrate trihydrate",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "Cu(NO_3)_2",
        "MOL_MASS": "241.60 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 3.0,
        "NFPA_B": 1.0,
        "NFPA_W": "OX",
        "CAS number": "10031-43-3",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화 구리",
        "IUPACNAME": "Copper(II) chloride dihydrate",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "CuCl2",
        "MOL_MASS": "170.48 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": "-",
        "CAS number": "10125-13-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "탄산 구리",
        "IUPACNAME": "Copper(II) carbonate, basic",
        "TRINAME": null,
        "LOCATION": "하",
        "MOL_FORMULA": "CuCO_3",
        "MOL_MASS": 123.5549,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "1184-64-1",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "사이클로헥산올",
        "IUPACNAME": "Cyclohexanone",
        "TRINAME": "Cyclohexanol",
        "LOCATION": "하",
        "MOL_FORMULA": "C_6H_12O",
        "MOL_MASS": "100.158 g/mol",
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "108-93-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": "n-butanol",
        "TRINAME": null,
        "LOCATION": "상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Barium carbonate",
        "TRINAME": null,
        "LOCATION": "상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "아디프산",
        "IUPACNAME": "Adipic Acid",
        "TRINAME": "Adipic Acid",
        "LOCATION": "1-4 (상)",
        "MOL_FORMULA": "(CH2)4(COOH)2",
        "MOL_MASS": "164.14 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "바세린",
        "IUPACNAME": "Vaseline, White",
        "TRINAME": "Vaseline, White",
        "LOCATION": "1-4 (상)",
        "MOL_FORMULA": "C15H15N",
        "MOL_MASS": "209.2863 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "올레산",
        "IUPACNAME": "Oleic Acid",
        "TRINAME": "Oleic Acid",
        "LOCATION": "1-4 (상)",
        "MOL_FORMULA": "CH3(CH2)7CH:CH(CH2)7(COOH)",
        "MOL_MASS": "282.47 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "옥살산",
        "IUPACNAME": "Oxalic Acid",
        "TRINAME": "Oxalic Acid",
        "LOCATION": "1-4 (상)",
        "MOL_FORMULA": "C2H2O4",
        "MOL_MASS": "무수물 : 90.034 g/mol/ 수화물 : 126.065 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 3.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "다이페닐옥살레이트",
        "IUPACNAME": "Diphenyl Oxalate",
        "TRINAME": "Diphenyl Oxalate",
        "LOCATION": "1-4 (상)",
        "MOL_FORMULA": "C14H10O4",
        "MOL_MASS": "242.23 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "아디프산",
        "IUPACNAME": "Adipic Acid",
        "TRINAME": "Adipic Acid",
        "LOCATION": "1-4 (상)",
        "MOL_FORMULA": "(CH2)4(COOH)2",
        "MOL_MASS": "164.14 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "제올라이트",
        "IUPACNAME": "Zeolite.Synthetic granular",
        "TRINAME": "Zeolite.Synthetic granular",
        "LOCATION": "1-4 (상)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "표준완충용액",
        "IUPACNAME": "Buffer Solution pH6.0±0.02 (25°C)",
        "TRINAME": "Buffer Solution",
        "LOCATION": "1-4 (상)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "표준완충용액",
        "IUPACNAME": "Buffer Solution \"Standard\" pH4.0 at 25°C",
        "TRINAME": "Buffer Solution \"Standard\"",
        "LOCATION": "1-4 (하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "제올라이트",
        "IUPACNAME": "Zeolite",
        "TRINAME": "Zeolite",
        "LOCATION": "1-4 (상)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "비타민 C",
        "IUPACNAME": "L-Ascorbic Acid",
        "TRINAME": "L-Ascorbic Acid",
        "LOCATION": "1-4 (상)",
        "MOL_FORMULA": "C6H8O6",
        "MOL_MASS": "176.13 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "표준완충용액",
        "IUPACNAME": "Buffer Solution \"Standard\" pH9.18 at 25°C",
        "TRINAME": "Buffer Solution \"Standard\"",
        "LOCATION": "1-4 (하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "삼산화비소",
        "IUPACNAME": "Arsenic(III) Trioxide",
        "TRINAME": "Arsenic(III) Trioxide",
        "LOCATION": "1-4 (상)",
        "MOL_FORMULA": "As2O3",
        "MOL_MASS": "197.84 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 3.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "옥살산수산",
        "IUPACNAME": "Oxalic Acid dihydrate",
        "TRINAME": "Oxalic Acid dihydrate",
        "LOCATION": "1-4 (상)",
        "MOL_FORMULA": "C2H2O42H2O",
        "MOL_MASS": "126.07 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "표준완충용액",
        "IUPACNAME": "Buffer Solution \"Standard\" pH4.0 at 25°C",
        "TRINAME": "Buffer Solution",
        "LOCATION": "1-4 (하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "칼륨",
        "IUPACNAME": "Potassium Standard Solution",
        "TRINAME": "Potassium Standard Solution",
        "LOCATION": "1-4 (하)",
        "MOL_FORMULA": "K",
        "MOL_MASS": "39.098 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "메탄올",
        "IUPACNAME": "Methly Alcohol",
        "TRINAME": "Methyl Alcohol",
        "LOCATION": "1-4 (하)",
        "MOL_FORMULA": "CH3OH",
        "MOL_MASS": "32.04 g/mol",
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "표준완충용액",
        "IUPACNAME": "Buffer Solution pH14 at 25°C",
        "TRINAME": "Buffer Solution",
        "LOCATION": "1-4 (하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "표준완충용액",
        "IUPACNAME": "Buffer Solution pH6 at 25°C",
        "TRINAME": "Buffer Solution",
        "LOCATION": "1-4 (하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "표준완충용액",
        "IUPACNAME": "Buffer Solution \"Standard\" pH7.0 (25°C)",
        "TRINAME": "Buffer Solution",
        "LOCATION": "1-4 (하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "표준완충용액",
        "IUPACNAME": "Buffer Solution \"Standard\" pH4.0 at 25°C",
        "TRINAME": "Buffer Solution",
        "LOCATION": "1-4 (하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "표준완충용액",
        "IUPACNAME": "Buffer Solution pH8.0±0.02 (25°C)",
        "TRINAME": "Buffer Solution",
        "LOCATION": "1-4 (하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "표준완충용액",
        "IUPACNAME": "Buffer Solutoin pH6.0±0.02 (25°C)",
        "TRINAME": "Buffer Solution",
        "LOCATION": "1-4 (하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "표준완충용액",
        "IUPACNAME": "Buffer Solution pH3 at 25°C",
        "TRINAME": "Buffer Solution",
        "LOCATION": "1-4 (하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "마그네슘 가루",
        "IUPACNAME": "Magnesium, Powder",
        "TRINAME": "Magnesium, Powder",
        "LOCATION": "2-1하",
        "MOL_FORMULA": "Mg",
        "MOL_MASS": "24.305 g/mol",
        "NFPA_R": 1,
        "NFPA_Y": 1,
        "NFPA_B": 0,
        "NFPA_W": null,
        "CAS number": "7439-95-4",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "마그네슘 리본",
        "IUPACNAME": "Magnesium ribbon",
        "TRINAME": "Magnesium ribbon",
        "LOCATION": "2-1하",
        "MOL_FORMULA": "Mg",
        "MOL_MASS": "24.305 g/mol",
        "NFPA_R": 1,
        "NFPA_Y": 1,
        "NFPA_B": 1,
        "NFPA_W": null,
        "CAS number": "7439-95-4",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "망간 2염화물",
        "IUPACNAME": "Manganese(II) chloride",
        "TRINAME": "Manganese(II) chloride",
        "LOCATION": "2-1하",
        "MOL_FORMULA": "MnCl2",
        "MOL_MASS": "125.8 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 1,
        "NFPA_W": null,
        "CAS number": "7773-01-5",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "산화 망가니즈",
        "IUPACNAME": "Manganese dioxide",
        "TRINAME": "Manganese dioxide",
        "LOCATION": "2-1하",
        "MOL_FORMULA": "MnO2",
        "MOL_MASS": "86.9368 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": null,
        "CAS number": "1313-13-9",
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "산화 망가니즈(IV)",
        "IUPACNAME": "Manganese(IV) oxide",
        "TRINAME": "Manganese(IV) oxide",
        "LOCATION": "2-1하",
        "MOL_FORMULA": "MnO2",
        "MOL_MASS": "86.9368 g/mol",
        "NFPA_R": 1,
        "NFPA_Y": 1,
        "NFPA_B": 2,
        "NFPA_W": "OX",
        "CAS number": "1313-13-9",
        "퍼센트": NaN,
        "COUNT": 3.0
    },
    {
        "KORNAME": "수산화 마그네슘",
        "IUPACNAME": "Magnesium hydroxide",
        "TRINAME": "Magnesium hydroxide",
        "LOCATION": "2-1하",
        "MOL_FORMULA": "Mg(OH)2",
        "MOL_MASS": "58.3197 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 0,
        "NFPA_W": null,
        "CAS number": "1309-42-8",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화 마그네슘",
        "IUPACNAME": "Magnesium chloride",
        "TRINAME": "Magnesium chloride",
        "LOCATION": "2-1하",
        "MOL_FORMULA": "MgCl2",
        "MOL_MASS": "95.211 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 0,
        "NFPA_W": null,
        "CAS number": "7786-30-3",
        "퍼센트": NaN,
        "COUNT": 2.0
    },
    {
        "KORNAME": "질산 마그네슘",
        "IUPACNAME": "Magnesium Nitrate",
        "TRINAME": "Magnesium Nitrate",
        "LOCATION": "2-1하",
        "MOL_FORMULA": "Mg(NO3)2",
        "MOL_MASS": "148.3 g/mol",
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "OX",
        "CAS number": "10377-60-3",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "황산 마그네슘",
        "IUPACNAME": "Magnesium sulfate",
        "TRINAME": "Magnesium sulfate",
        "LOCATION": "2-1하",
        "MOL_FORMULA": "MgSO4",
        "MOL_MASS": "120.366 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 0,
        "NFPA_W": null,
        "CAS number": "7487-88-9",
        "퍼센트": NaN,
        "COUNT": 3.0
    },
    {
        "KORNAME": "황산 망가니즈",
        "IUPACNAME": "Manganese sulfate monohydrate",
        "TRINAME": "Manganese sulfate",
        "LOCATION": "2-1하",
        "MOL_FORMULA": "MnSO4 H2O",
        "MOL_MASS": "151.001 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 1,
        "NFPA_B": 1,
        "NFPA_W": null,
        "CAS number": "10034-96-5",
        "퍼센트": NaN,
        "COUNT": 2.0
    },
    {
        "KORNAME": "황산 망가니즈",
        "IUPACNAME": "Manganese sulfate heptahydrate",
        "TRINAME": "Manganese sulfate",
        "LOCATION": "2-1하",
        "MOL_FORMULA": "MnSO4 7H2O",
        "MOL_MASS": "151.001 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 1,
        "NFPA_B": 1,
        "NFPA_W": null,
        "CAS number": "13492-24-5",
        "퍼센트": NaN,
        "COUNT": 2.0
    },
    {
        "KORNAME": "마그네슘 가루",
        "IUPACNAME": "Magnesium, Powder",
        "TRINAME": "Magnesium, Powder",
        "LOCATION": "2-1상",
        "MOL_FORMULA": "Mg",
        "MOL_MASS": "24.305 g/mol",
        "NFPA_R": 1,
        "NFPA_Y": 1,
        "NFPA_B": 0,
        "NFPA_W": null,
        "CAS number": "7439-95-4",
        "퍼센트": NaN,
        "COUNT": 4.0
    },
    {
        "KORNAME": "말레산",
        "IUPACNAME": "Maleic acid",
        "TRINAME": "Maleic acid",
        "LOCATION": "2-1상",
        "MOL_FORMULA": "(CHCOOH)2",
        "MOL_MASS": "116.07 g/mol",
        "NFPA_R": 1,
        "NFPA_Y": 1,
        "NFPA_B": 2,
        "NFPA_W": null,
        "CAS number": "110-16-7",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "말론산",
        "IUPACNAME": "Malonic acid",
        "TRINAME": "Malonic acid",
        "LOCATION": "2-1상",
        "MOL_FORMULA": "C3H4O4",
        "MOL_MASS": "104.0615 g/mol",
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": null,
        "CAS number": "141-82-2",
        "퍼센트": NaN,
        "COUNT": 2.0
    },
    {
        "KORNAME": "분자체",
        "IUPACNAME": "Molecular sieves, 3A",
        "TRINAME": "Molcular sieves, 3A",
        "LOCATION": "2-1상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 0,
        "NFPA_W": null,
        "CAS number": "1318-02-1",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "분자체",
        "IUPACNAME": "Molecular sieves, 4A",
        "TRINAME": "Mocular sieves, 4A",
        "LOCATION": "2-1상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": 0,
        "NFPA_Y": 1,
        "NFPA_B": 1,
        "NFPA_W": null,
        "CAS number": "1318-02-1",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "산화 마그네슘",
        "IUPACNAME": "Magnesium oxide, heavy",
        "TRINAME": "Magnesium oxide, heavy",
        "LOCATION": "2-1상",
        "MOL_FORMULA": "MgO",
        "MOL_MASS": "40.3044 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 0,
        "NFPA_W": null,
        "CAS number": "1309-48-4",
        "퍼센트": NaN,
        "COUNT": 3.0
    },
    {
        "KORNAME": "산화 텅스텐(VI)",
        "IUPACNAME": "Tungsten(VI) oxide",
        "TRINAME": "Tungsten(VI) oxide",
        "LOCATION": "2-1상",
        "MOL_FORMULA": "O3W",
        "MOL_MASS": "231.84 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 0,
        "NFPA_W": null,
        "CAS number": "1314-35-8",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화 수은",
        "IUPACNAME": "Mercury(II) chloride",
        "TRINAME": "Mercury(II) chloride",
        "LOCATION": "2-1상",
        "MOL_FORMULA": "HgCl2",
        "MOL_MASS": "271.52 g/mol",
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 4,
        "NFPA_W": null,
        "CAS number": "7487-94-7",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "황화 나트륨",
        "IUPACNAME": NaN,
        "TRINAME": "Sodium Sulfide",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": "Na2S.nH2O",
        "MOL_MASS": 78.04,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 60,
        "COUNT": 5.0
    },
    {
        "KORNAME": "아황산 나트륨",
        "IUPACNAME": NaN,
        "TRINAME": "Sodium Sulfite",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": "Na2SO3",
        "MOL_MASS": 126.04,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 95,
        "COUNT": 1.0
    },
    {
        "KORNAME": "싸이오황산 나트륨(티오황산 나트륨)",
        "IUPACNAME": NaN,
        "TRINAME": "Sodium Thiosulfate",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": "Na2O3S2.5H2O",
        "MOL_MASS": 248.18,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 98.5,
        "COUNT": 2.0
    },
    {
        "KORNAME": "황산 나트륨",
        "IUPACNAME": NaN,
        "TRINAME": "Sodium Sulfite anhydrous",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": "Na2SO4",
        "MOL_MASS": 142.04,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 99,
        "COUNT": 1.0
    },
    {
        "KORNAME": "황산 나트륨",
        "IUPACNAME": NaN,
        "TRINAME": "Sodium Sulfite anhydrous",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": "Na2SO4",
        "MOL_MASS": 142.04,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 95,
        "COUNT": 1.0
    },
    {
        "KORNAME": "수산화 나트륨 용액",
        "IUPACNAME": NaN,
        "TRINAME": "Sodium Hydroxide Solution",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": "1M",
        "COUNT": 1.0
    },
    {
        "KORNAME": "탄산 나트륨",
        "IUPACNAME": NaN,
        "TRINAME": "Sodium Carbonate",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": "Na2CO3",
        "MOL_MASS": 105.99,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 99.5,
        "COUNT": 1.0
    },
    {
        "KORNAME": "피로아황산 나트륨(메타중아황산나트륨)",
        "IUPACNAME": NaN,
        "TRINAME": "Sodium Disulfite",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": "Na2S2O5",
        "MOL_MASS": 190.11,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 97,
        "COUNT": 1.0
    },
    {
        "KORNAME": "옥살산 나트륨",
        "IUPACNAME": NaN,
        "TRINAME": "Sodium Oxalate",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": "Na2C2O4",
        "MOL_MASS": 134.0,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 99,
        "COUNT": 1.0
    },
    {
        "KORNAME": "염산 표준 용액 (노르말 농도 참조)",
        "IUPACNAME": NaN,
        "TRINAME": "Hydrochloric Acid Standard Solution",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": "HCl",
        "MOL_MASS": 36.45,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": "1N",
        "COUNT": 1.0
    },
    {
        "KORNAME": "메탄올",
        "IUPACNAME": NaN,
        "TRINAME": "Methyl Alcohol",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": "CH3OH",
        "MOL_MASS": 32.04,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 99.5,
        "COUNT": 1.0
    },
    {
        "KORNAME": "황산 용액",
        "IUPACNAME": NaN,
        "TRINAME": "Sulfuric Acid Solution",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": "H2SO4",
        "MOL_MASS": 98.08,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": "1N",
        "COUNT": 1.0
    },
    {
        "KORNAME": "황산 표준 용액 (노르말 농도 참조) ",
        "IUPACNAME": NaN,
        "TRINAME": "Sulfuric Acid Standard Solution",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": "H2SO4",
        "MOL_MASS": 98.08,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": "0.05N",
        "COUNT": 1.0
    },
    {
        "KORNAME": "황산 용액",
        "IUPACNAME": NaN,
        "TRINAME": "Sulfuric Acid Solution",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": "H2SO4",
        "MOL_MASS": 98.08,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": "1M",
        "COUNT": 1.0
    },
    {
        "KORNAME": "황산 용액",
        "IUPACNAME": NaN,
        "TRINAME": "Sulfuric Acid Solution",
        "LOCATION": "2-2 상",
        "MOL_FORMULA": "H2SO4",
        "MOL_MASS": 98.08,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 95,
        "COUNT": 1.0
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": null,
        "LOCATION": null,
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "2-2 상 중에서 위에 절반입니다.",
        "IUPACNAME": NaN,
        "TRINAME": null,
        "LOCATION": null,
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "이어서 정리할 천사분은",
        "IUPACNAME": NaN,
        "TRINAME": null,
        "LOCATION": null,
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "2-2 상에서 아래 칸",
        "IUPACNAME": NaN,
        "TRINAME": null,
        "LOCATION": null,
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "부탁드립니다.",
        "IUPACNAME": NaN,
        "TRINAME": null,
        "LOCATION": null,
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "탄산나트륨",
        "IUPACNAME": "Sodium Carbonate",
        "TRINAME": "Sodium carbonate",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "Na2CO3",
        "MOL_MASS": "106 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "탄산나트륨(무수물)",
        "IUPACNAME": "Sodium Carbonate Anhydrous",
        "TRINAME": "Soda ash Anhydrous",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "Na2CO3",
        "MOL_MASS": "105.99 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": "497-19-8",
        "퍼센트": 0.99,
        "COUNT": 6.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "요오드화나트륨",
        "IUPACNAME": "Sodium Iodide",
        "TRINAME": "Sodium Iodine",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "NaI",
        "MOL_MASS": "149.9 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": 2.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "티오황산나트륨(무수물)",
        "IUPACNAME": "Sodium thiosulfate-Anhydrous",
        "TRINAME": "Sodium hyposulfite-Anhydrous",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "Na2S2O3",
        "MOL_MASS": "158.11 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": "7640-4400",
        "퍼센트": 0.95,
        "COUNT": 2.0,
        "Unnamed: 13": 2.0
    },
    {
        "KORNAME": "탄사수소나트륨",
        "IUPACNAME": "Sodium hydrogen carbonate",
        "TRINAME": "Baking soda",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "NaHCO3",
        "MOL_MASS": "84.01 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": "144-55-8",
        "퍼센트": 0.9988,
        "COUNT": 5.0,
        "Unnamed: 13": 4.0
    },
    {
        "KORNAME": "붕산 나트륨 10수화물",
        "IUPACNAME": "Sodium tetraborate decahydrate",
        "TRINAME": "Borax octahydrate",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "Na2B4O7·10H2O",
        "MOL_MASS": "381.37 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": "1303-96-4",
        "퍼센트": 1.01,
        "COUNT": 3.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "요오드화나트륨",
        "IUPACNAME": "Sodium Iodide",
        "TRINAME": "Sodium Iodine",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "NaI",
        "MOL_MASS": "149.9 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": "7681-82-5",
        "퍼센트": 0.99,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "황산아연",
        "IUPACNAME": "Zinc sulfate",
        "TRINAME": "White vitriol",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "ZnSO4",
        "MOL_MASS": "287.56 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 3.0,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "알긴산 나트륨",
        "IUPACNAME": "Sodium alginate",
        "TRINAME": "Sodium salt of alginate",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "C6H9NaO6",
        "MOL_MASS": null,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": NaN,
        "CAS number": "9005-38-3",
        "퍼센트": NaN,
        "COUNT": 2.0,
        "Unnamed: 13": 2.0
    },
    {
        "KORNAME": "티오황산나트륨(오수화물)",
        "IUPACNAME": "Sodium thiosulfate-Pentahydrtae",
        "TRINAME": "Sodium hyposulfite-Pentahydrate",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "Na2S2O3-5H2O",
        "MOL_MASS": "248.18 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": "10102-17-7",
        "퍼센트": 0.99,
        "COUNT": 3.0,
        "Unnamed: 13": 2.0
    },
    {
        "KORNAME": "알긴산 나트륨90.8%",
        "IUPACNAME": "Sodium alginate",
        "TRINAME": "Sodium salt of alginate",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "C6H9NaO6",
        "MOL_MASS": null,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": NaN,
        "CAS number": "9005-38-3",
        "퍼센트": 0.908,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "아세트산 나트륨 삼수화물",
        "IUPACNAME": "Sodium acetate trihydrate",
        "TRINAME": "Sodium acetate trihydrate",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "CH3COONA-3H2O",
        "MOL_MASS": "136.09 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": 3.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "황산수소나트륨(무수물)",
        "IUPACNAME": "Sodium acid sulfate anhydrous",
        "TRINAME": "Sodium acid sulfate anhydrous",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "NaHSO4",
        "MOL_MASS": "120.06g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": "7681-38-1",
        "퍼센트": 0.94,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "황산수소나트륨(무수물)",
        "IUPACNAME": "Sodium acetate,Anhydrous",
        "TRINAME": "Sodium ethanoate,Anhydrous",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "CH3COONa",
        "MOL_MASS": "82.04g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": "0127-09-03",
        "퍼센트": 0.98,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "황산",
        "IUPACNAME": "Sulfuric acid ",
        "TRINAME": "Hydrogen sulfate",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "H2SO4",
        "MOL_MASS": "       98.079g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 2.0,
        "NFPA_B": 3.0,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "황산",
        "IUPACNAME": "Sulfuric acid ",
        "TRINAME": "Hydrogen sulfate",
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": "H2SO4",
        "MOL_MASS": "       98.079g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 2.0,
        "NFPA_B": 3.0,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": null,
        "TRINAME": null,
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": null,
        "TRINAME": null,
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": null,
        "TRINAME": null,
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": null,
        "TRINAME": null,
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": null,
        "TRINAME": null,
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": null,
        "TRINAME": null,
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": null,
        "TRINAME": null,
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": null,
        "TRINAME": null,
        "LOCATION": "2-2(하)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": null,
        "TRINAME": null,
        "LOCATION": null,
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "폼산",
        "IUPACNAME": "Formic acid",
        "TRINAME": "Methanoic acid",
        "LOCATION": null,
        "MOL_FORMULA": "CH2O2",
        "MOL_MASS": "46.03 g/mol",
        "NFPA_R": 2.0,
        "NFPA_Y": NaN,
        "NFPA_B": 3.0,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "지르코늄디옥사이드",
        "IUPACNAME": "Zirconium(IV) Oxide",
        "TRINAME": "Zirconium(IV) Oxide",
        "LOCATION": "2-3 (하)",
        "MOL_FORMULA": "ZrO2",
        "MOL_MASS": 123.22,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "실버 페이스트",
        "IUPACNAME": "Elcoat Silver Paste P-100",
        "TRINAME": "Elcoat Silver Paste P-100",
        "LOCATION": "2-3 (하)",
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "치오",
        "IUPACNAME": "Thiourea",
        "TRINAME": "Thiourea",
        "LOCATION": "2-3 (하)",
        "MOL_FORMULA": "H2NCSNH2",
        "MOL_MASS": 76.12,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "티타늄 아이소프로폭시드",
        "IUPACNAME": "Titanium Tetraisopropoxide",
        "TRINAME": "Titanium(IV) Isopropoxide",
        "LOCATION": "2-3 (하)",
        "MOL_FORMULA": "Ti[OCH(CH3)2]4",
        "MOL_MASS": 284.26,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": "98%~",
        "COUNT": NaN
    },
    {
        "KORNAME": "톨루엔",
        "IUPACNAME": "Toluene",
        "TRINAME": "Toluene",
        "LOCATION": "2-3 (하)",
        "MOL_FORMULA": "C6H5CH3",
        "MOL_MASS": 92.14,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산아연",
        "IUPACNAME": "Zinc Nitrate Hexahydrate",
        "TRINAME": "Zinc Nitrate Hexahydrate",
        "LOCATION": "2-3 (하)",
        "MOL_FORMULA": "N2O6Zn⋅6H2O",
        "MOL_MASS": 297.51,
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 1.0,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "크실렌",
        "IUPACNAME": "Xylene",
        "TRINAME": "Xylene",
        "LOCATION": "2-3 (하)",
        "MOL_FORMULA": "C6H4(CH3)2",
        "MOL_MASS": 106.17,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": "95%~",
        "COUNT": NaN
    },
    {
        "KORNAME": "아연",
        "IUPACNAME": "Zinc, powder",
        "TRINAME": "Zinc, powder",
        "LOCATION": "2-3 (하)",
        "MOL_FORMULA": "Zn",
        "MOL_MASS": 65.39,
        "NFPA_R": 4.0,
        "NFPA_Y": 3.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "산화아연",
        "IUPACNAME": "Zinc oxide",
        "TRINAME": "Zinc oxide",
        "LOCATION": "2-3 (하)",
        "MOL_FORMULA": "OZn",
        "MOL_MASS": 81.39,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산아연",
        "IUPACNAME": "Zinc Nitrate Hexahydrate",
        "TRINAME": "Zinc Nitrate Hexahydrate",
        "LOCATION": "2-3 (하)",
        "MOL_FORMULA": "N2O6Zn⋅6H2O",
        "MOL_MASS": 297.51,
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 1.0,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산아연",
        "IUPACNAME": "Zinc Nitrate Hexahydrate",
        "TRINAME": "Zinc Nitrate Hexahydrate",
        "LOCATION": "2-3 (하)",
        "MOL_FORMULA": "N2O6Zn⋅6H2O",
        "MOL_MASS": 297.51,
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 1.0,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "메틸렌 블루",
        "IUPACNAME": "Methylene Blue",
        "TRINAME": "Metylene Blue",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "C16H18N3SCl",
        "MOL_MASS": NaN,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 1,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "규산 나트륨",
        "IUPACNAME": "Sodium Silicate, Solution",
        "TRINAME": "Sodium Silicate, Solution",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "Na2SiO3",
        "MOL_MASS": 122.06,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": "Na2O 9~19%\nSiO2 28~38%",
        "COUNT": NaN
    },
    {
        "KORNAME": "질산은",
        "IUPACNAME": "Silver Nitrate",
        "TRINAME": "Silver Nitrate",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.89,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": "0.05M",
        "COUNT": NaN
    },
    {
        "KORNAME": "주석산나트륨삼수화물",
        "IUPACNAME": "Sodium Stannate Trihydrate",
        "TRINAME": "Sodium Stannate Trihydrate",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "Na2SnO3⋅3H2O",
        "MOL_MASS": 266.71,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "플루오린화 나트륨",
        "IUPACNAME": "Sodium Silicofluoride",
        "TRINAME": "Sodium Silicofluoride",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "Na2SiF6",
        "MOL_MASS": 188.06,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": "98%~",
        "COUNT": NaN
    },
    {
        "KORNAME": "주석산나트륨삼수화물",
        "IUPACNAME": "Sodium Stannate Trihydrate",
        "TRINAME": "Sodium Stannate Trihydrate",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "Na2SnO3⋅3H2O",
        "MOL_MASS": 266.71,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산은 용액",
        "IUPACNAME": "Silver Nitrate Solution",
        "TRINAME": "Silver Nitrate Solution",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.89,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산은",
        "IUPACNAME": "Silver Nitrate",
        "TRINAME": "Silver Nitrate",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.87,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "규산 나트륨",
        "IUPACNAME": "Sodium Silicate, Solution",
        "TRINAME": "Sodium Silicate, Solution",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "Na2SiO3",
        "MOL_MASS": 122.06,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산은",
        "IUPACNAME": "Silver Nitrate",
        "TRINAME": "Silver Nitrate",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.87,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산은",
        "IUPACNAME": "Silver Nitrate",
        "TRINAME": "Silver Nitrate",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.87,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "규산 나트륨",
        "IUPACNAME": "Sodium Silicate (Powder)",
        "TRINAME": "Sodium Silicate (Powder)",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "Na2SiO3",
        "MOL_MASS": 122.06,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산은",
        "IUPACNAME": "Silver Nitrate",
        "TRINAME": "Silver Nitrate",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.87,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산은 용액",
        "IUPACNAME": "Silver Nitrate Solution 0.05mol/L",
        "TRINAME": "Silver Nitrate Solution 0.05mol/L",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.89,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "황산은",
        "IUPACNAME": "Silver sulfate",
        "TRINAME": "Silver sulfate",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "Ag2SO4",
        "MOL_MASS": 311.83,
        "NFPA_R": 0,
        "NFPA_Y": 1,
        "NFPA_B": 3,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산은",
        "IUPACNAME": "Silver Nitrate",
        "TRINAME": "Silver Nitrate",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.87,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "규산 나트륨",
        "IUPACNAME": "Sodium Silicate (Powder)",
        "TRINAME": "Sodium Silicate (Powder)",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "Na2SiO3",
        "MOL_MASS": 122.06,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "규산 나트륨",
        "IUPACNAME": "Sodium Silicate, Solution",
        "TRINAME": "Sodium Silicate, Solution",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "Na2SiO3",
        "MOL_MASS": 122.06,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": "Na2O 9~19%\nSiO2 28~38%",
        "COUNT": NaN
    },
    {
        "KORNAME": "염화세바코일",
        "IUPACNAME": "Sebacoyl chloride",
        "TRINAME": "Sebacoyl chloride",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "C10H16Cl2O2",
        "MOL_MASS": 239.14,
        "NFPA_R": 1,
        "NFPA_Y": 2,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": 0.98,
        "COUNT": NaN
    },
    {
        "KORNAME": "규산 나트륨",
        "IUPACNAME": "Sodium Silicate, Solution",
        "TRINAME": "Sodium Silicate, Solution",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "Na2SiO3",
        "MOL_MASS": 122.06,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": "Na2O 9~19%\nSiO2 28~38%",
        "COUNT": NaN
    },
    {
        "KORNAME": "질산은",
        "IUPACNAME": "Silver Nitrate",
        "TRINAME": "Silver Nitrate",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.87,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "황산 나트륨",
        "IUPACNAME": "Sodium Sulfate",
        "TRINAME": "Sodium Sulfate",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "Na2SO4",
        "MOL_MASS": 142.05,
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 1,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산은 용액",
        "IUPACNAME": "0.1N-Silver(I) nitrate standard solution",
        "TRINAME": "0.1N-Silver(I) nitrate standard solution",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.89,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": "1M",
        "COUNT": NaN
    },
    {
        "KORNAME": "질산은",
        "IUPACNAME": "Silver Nitrate",
        "TRINAME": "Silver Nitrate",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.87,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화세바코일",
        "IUPACNAME": "Sebacoyl chloride",
        "TRINAME": "Sebacoyl chloride",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "C10H16Cl2O2",
        "MOL_MASS": 239.14,
        "NFPA_R": 1,
        "NFPA_Y": 2,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": 0.98,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산은 용액",
        "IUPACNAME": "0.1N-Silver(I) nitrate standard solution",
        "TRINAME": "0.1N-Silver(I) nitrate standard solution",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.89,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": "1M",
        "COUNT": NaN
    },
    {
        "KORNAME": "염화은",
        "IUPACNAME": "Silver Chloride, 99.5%",
        "TRINAME": "Silver Chloride, 99.5%",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgCl",
        "MOL_MASS": 143.32,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 1,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산은 용액",
        "IUPACNAME": "0.1N-Silver(I) nitrate standard solution",
        "TRINAME": "0.1N-Silver(I) nitrate standard solution",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.89,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": "1M",
        "COUNT": NaN
    },
    {
        "KORNAME": "질산은",
        "IUPACNAME": "Silver Nitrate",
        "TRINAME": "Silver Nitrate",
        "LOCATION": "2-4 (상)",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.87,
        "NFPA_R": 0,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": 0.0,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "알리자린 레드 S",
        "IUPACNAME": "3,4-Dihydroxy-9,10-dioxo-9,10-dihydroanthracene-2-sulfonic acid",
        "TRINAME": "Alizarin Red S",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C14H7NaO7S",
        "MOL_MASS": "342.26",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "130-22-3",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": 90.0
    },
    {
        "KORNAME": "알리자린 옐로 GG",
        "IUPACNAME": "5-(3-Nitrophenylazo)salicylic acid sodium salt",
        "TRINAME": "Alizarin Yellow GG",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C13H8N3NaO5",
        "MOL_MASS": "309.21",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "584-42-9",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "세릭암모늄나이트레이트",
        "IUPACNAME": "Diammonium cerium(IV) nitrate",
        "TRINAME": "Ammonium cerium(IV) nitrate",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "CeH8N8O18",
        "MOL_MASS": "548.22",
        "NFPA_R": "1",
        "NFPA_Y": "1",
        "NFPA_B": "2",
        "NFPA_W": "OX",
        "CAS number": "16774-21-3",
        "퍼센트": "95",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "아닐린 블루",
        "IUPACNAME": "Benzenesulfonic acid, aminomethyl[[4-[(sulfophenyl)amino]phenyl][4-[(sulfophenyl)imino]-2,5-cyclohexadien-1-ylidene]methyl]-, sodium salt (1:2)",
        "TRINAME": "Aniline Blue",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C32H25N3Na2O9S3",
        "MOL_MASS": "737.74",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "28631-66-5",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "베네딕트 용액",
        "IUPACNAME": "Benedict Solution",
        "TRINAME": "Benedict Solution",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "-",
        "MOL_MASS": "-",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "3",
        "NFPA_W": "-",
        "CAS number": "-",
        "퍼센트": "-",
        "COUNT": 3,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "끓임쪽",
        "IUPACNAME": "Boiling stone",
        "TRINAME": "Boiling stone",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "-",
        "MOL_MASS": "-",
        "NFPA_R": "-",
        "NFPA_Y": "-",
        "NFPA_B": "-",
        "NFPA_W": "-",
        "CAS number": "-",
        "퍼센트": "-",
        "COUNT": 2,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "B.T.B 용액",
        "IUPACNAME": "3,3-Bis[3-bromo-4-hydroxy-2-methyl-5-(propan-2-yl)phenyl]-2,1λ6-benzoxathiole-1,1(3H)-dione",
        "TRINAME": "Bromo Thymol Blue Solution",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C27H28Br2O5S",
        "MOL_MASS": "624.38",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "76-59-5",
        "퍼센트": "-",
        "COUNT": 4,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "브로모크레졸 그린",
        "IUPACNAME": "3′,3″,5′,5″-Tetrabromo-m-cresolsulfonphthalein sodium salt",
        "TRINAME": "Bromocresol green",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C21H13Br4O5SNa",
        "MOL_MASS": "720.00",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "263-657-4",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "카민액",
        "IUPACNAME": "(1R)-1,5-Anhydro-1-(7-carboxy-1,3,4,6-tetrahydroxy-8-methyl-9,10-dioxo-9,10-dihydro-2-anthracenyl)-D-glucitol",
        "TRINAME": "Carmine Solution",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C22H20O13",
        "MOL_MASS": "492.40",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "0",
        "NFPA_W": "-",
        "CAS number": "1390-65-4",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "시트라코닉산, 무수화물",
        "IUPACNAME": "(2Z)-2-Methylbut-2-enedioic acid",
        "TRINAME": "Citraconic anhydride",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C5H6O4",
        "MOL_MASS": "130.10",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "498-23-7",
        "퍼센트": "98",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "dl-알파 토코페롤",
        "IUPACNAME": "(2R)-2,5,7,8-Tetramethyl-2-[(4R,8R)-4,8,12-trimethyltridecyl]-3,4-dihydro-2H-1-benzopyran-6-ol",
        "TRINAME": "dl-alpha-Tocopherol",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C29H50O2",
        "MOL_MASS": "430.71",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "59-02-09",
        "퍼센트": "97",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "에오신 Y",
        "IUPACNAME": "2-(2,4,5,7-tetrabromo-6-oxido-3-oxo-3H-xanthen-9-yl)benzoate [in its deprotonated form]",
        "TRINAME": "Eosin Y",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C20H6Br4Na2O5",
        "MOL_MASS": "647.89",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "17372-87-1",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "에오신 Y, 수용성",
        "IUPACNAME": "2-(2,4,5,7-tetrabromo-6-oxido-3-oxo-3H-xanthen-9-yl)benzoate [in its deprotonated form]",
        "TRINAME": "Eosin Y, water soluble",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C20H6Br4Na2O5",
        "MOL_MASS": "647.89",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "17372-87-1",
        "퍼센트": "80",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "펠링 용액 A",
        "IUPACNAME": "Copper(II) sulfate",
        "TRINAME": "Fehling's solution A",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "CuSO4",
        "MOL_MASS": "159.60",
        "NFPA_R": "0",
        "NFPA_Y": "1",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "7758-98-7",
        "퍼센트": "-",
        "COUNT": 2,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "펠링 용액 B",
        "IUPACNAME": "Sodium potassium L(+)-tartrate tetrahydrate",
        "TRINAME": "Fehling's solution B",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "KNaC4H4O6·4H2O",
        "MOL_MASS": "282.22",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "6381-59-5",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "플루오린화 나트륨",
        "IUPACNAME": "Sodium fluoride",
        "TRINAME": "Florocid",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "NaF",
        "MOL_MASS": "41.99",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "3",
        "NFPA_W": "-",
        "CAS number": "7681-49-4",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "김사 용액",
        "IUPACNAME": "7-amino-N,N-dimethyl-3H-phenothiazin-3-iminium chloride",
        "TRINAME": "Giemsa Solution",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C14H14ClN3S",
        "MOL_MASS": "291.80",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "51811-82-6",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "인디고",
        "IUPACNAME": "[2(2')E]-[2,2'-Biindolylidene]-3,3'(1H,1'H)-dione",
        "TRINAME": "Indigo",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C16H10N2O2",
        "MOL_MASS": "262.27",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "64784-13-0",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "인디고 카민",
        "IUPACNAME": "Disodium [2(2′)E]-3,3′-dioxo-1,1′,3,3′-tetrahydro[2,2′-biindolylidene]-5,5′-disulfonate",
        "TRINAME": "Indigo carmine",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C16H8N2Na2O8S2",
        "MOL_MASS": "466.36",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "860-22-0",
        "퍼센트": "-",
        "COUNT": 2,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "리놀레산",
        "IUPACNAME": "(9Z,12Z)-octadeca-9,12-dienoic acid",
        "TRINAME": "Linoleic Acid",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C18H32O2",
        "MOL_MASS": "280.45",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "60-33-3",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "리트머스 용액",
        "IUPACNAME": "Litmus Solution",
        "TRINAME": "Litmus Solution",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "-",
        "MOL_MASS": "-",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "1393-92-6",
        "퍼센트": "-",
        "COUNT": 2,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "리트머스 가루",
        "IUPACNAME": "Litmus, powder",
        "TRINAME": "Litmus, powder",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "-",
        "MOL_MASS": "-",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "1393-92-6",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "산화 수은(II)",
        "IUPACNAME": "Mercury(II) oxide",
        "TRINAME": "Mercuric Oxide, Yellow",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "HgO",
        "MOL_MASS": "216.59",
        "NFPA_R": "0",
        "NFPA_Y": "2",
        "NFPA_B": "4",
        "NFPA_W": "-",
        "CAS number": "21908-53-2",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "황산 수은(II)",
        "IUPACNAME": "Mercury(II) sulfate",
        "TRINAME": "Mercuric sulfate",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "HgSO4",
        "MOL_MASS": "296.65",
        "NFPA_R": "0",
        "NFPA_Y": "1",
        "NFPA_B": "3",
        "NFPA_W": "-",
        "CAS number": "7783-35-9",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "메틸 오렌지",
        "IUPACNAME": "Sodium 4-{[4-(dimethylamino)phenyl]diazenyl}benzene-1-sulfonate",
        "TRINAME": "Methyl Orange",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C14H14N3NaO3S",
        "MOL_MASS": "327.34",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "547-58-0",
        "퍼센트": "-",
        "COUNT": 4,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "메틸 오렌지 용액",
        "IUPACNAME": "Sodium 4-{[4-(dimethylamino)phenyl]diazenyl}benzene-1-sulfonate",
        "TRINAME": "Methyl Orange Solution",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C14H14N3NaO3S",
        "MOL_MASS": "327.34",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "547-58-0",
        "퍼센트": "-",
        "COUNT": 2,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "메틸 레드",
        "IUPACNAME": "2-{[4-(Dimethylamino)phenyl]diazenyl}benzoic acid",
        "TRINAME": "Methyl Red",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C15H15N3O2",
        "MOL_MASS": "269.31",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "493-52-7",
        "퍼센트": "-",
        "COUNT": 2,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "메틸 바이올렛 6B",
        "IUPACNAME": "Benzenamine, 4,4′-[[4-(methylimino)-2,5-cyclohexadien-1-ylidene]methylene]bis[N,N-dimethyl-, hydrochloride (1:1)",
        "TRINAME": "Methyl Violet 6B",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C24H28N3Cl",
        "MOL_MASS": "393.95",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "3",
        "NFPA_W": "-",
        "CAS number": "603-47-4",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "메틸렌 블루",
        "IUPACNAME": "3,7-bis(Dimethylamino)-phenothiazin-5-ium chloride",
        "TRINAME": "Methylene Blue",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C16H18Cl2N3S",
        "MOL_MASS": "319.85",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "122965-43-9",
        "퍼센트": "-",
        "COUNT": 2,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "메틸렌 블루",
        "IUPACNAME": "3,7-bis(Dimethylamino)-phenothiazin-5-ium chloride",
        "TRINAME": "Methylene Blue",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C16H18Cl2N3S.nH2O",
        "MOL_MASS": "319.85",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "122965-43-9",
        "퍼센트": "95",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "메틸렌 블루 4수화물",
        "IUPACNAME": "3,7-bis(Dimethylamino)-phenothiazin-5-ium chloride tetrahydrate",
        "TRINAME": "Methylene Blue, Tetrahydrate",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C16H18Cl2N3S.4H2O",
        "MOL_MASS": "391.90",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "61-73-4",
        "퍼센트": "95",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "다이클로로메탄",
        "IUPACNAME": "Dichloromethane",
        "TRINAME": "Methylene Chloride",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "CH2Cl2",
        "MOL_MASS": "84.93",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "75-09-02",
        "퍼센트": "99",
        "COUNT": 3,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "네슬러시약",
        "IUPACNAME": "potassium tetraiodidomercurate(II)",
        "TRINAME": "Nessler′s reagent",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "K2HgI4",
        "MOL_MASS": "786.40",
        "NFPA_R": "1",
        "NFPA_Y": "1",
        "NFPA_B": "4",
        "NFPA_W": "-",
        "CAS number": "7783-33-7",
        "퍼센트": "-",
        "COUNT": 2,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "닌하이드린",
        "IUPACNAME": "2,2-Dihydroxy-1H-indene-1,3(2H)-dione",
        "TRINAME": "Ninhydrin",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C9H6O4",
        "MOL_MASS": "178.14",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "485-47-2",
        "퍼센트": "97",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "닌하이드린",
        "IUPACNAME": "2,2-Dihydroxy-1H-indene-1,3(2H)-dione",
        "TRINAME": "Ninhydrin",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C9H6O4",
        "MOL_MASS": "178.14",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "485-47-2",
        "퍼센트": "98",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "페놀 레드, 지시약",
        "IUPACNAME": "4,4′-(1,1-Dioxido-3H-2,1-benzoxathiole-3,3-diyl)diphenol",
        "TRINAME": "Phenol Red, Indicator",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C19H14O5S",
        "MOL_MASS": "354.38",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "143-74-8",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "페놀프탈레인 용액",
        "IUPACNAME": "3,3-Bis(4-hydroxyphenyl)-2-benzofuran-1(3H)-one",
        "TRINAME": "Phenolphthalein Solution",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C20H14O4",
        "MOL_MASS": "318.32",
        "NFPA_R": "3",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "77-09-08",
        "퍼센트": "0.1",
        "COUNT": 3,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "옥도가리",
        "IUPACNAME": "Potassium iodide",
        "TRINAME": "Potassium iodide",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "KI",
        "MOL_MASS": "166.00",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "7681-11-0",
        "퍼센트": "-",
        "COUNT": 3,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "붕사, 액체",
        "IUPACNAME": "disodium;3,7-dioxido-2,4,6,8,9-pentaoxa-1,3,5,7-tetraborabicyclo[3.3.1]nonane;decahydrate",
        "TRINAME": "Sodium Borax",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "Na2B4O7",
        "MOL_MASS": "201.22",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "1330-43-4",
        "퍼센트": "-",
        "COUNT": 4,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "붕사, 가루",
        "IUPACNAME": "disodium;3,7-dioxido-2,4,6,8,9-pentaoxa-1,3,5,7-tetraborabicyclo[3.3.1]nonane;decahydrate",
        "TRINAME": "Sodium Borax",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "Na2B4O7",
        "MOL_MASS": "201.22",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "1330-43-4",
        "퍼센트": "-",
        "COUNT": 2,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "수소화 붕소 나트륨",
        "IUPACNAME": "Sodium tetrahydridoborate(1–)",
        "TRINAME": "Sodium Borohydride",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "NaBH4",
        "MOL_MASS": "37.83",
        "NFPA_R": "1",
        "NFPA_Y": "2",
        "NFPA_B": "3",
        "NFPA_W": "W",
        "CAS number": "16940-66-2",
        "퍼센트": "92",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "수소화 붕소 나트륨, 가루",
        "IUPACNAME": "Sodium tetrahydridoborate(1–)",
        "TRINAME": "Sodium Borohydride Powder",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "NaBH4",
        "MOL_MASS": "37.83",
        "NFPA_R": "1",
        "NFPA_Y": "2",
        "NFPA_B": "3",
        "NFPA_W": "W",
        "CAS number": "16940-66-2",
        "퍼센트": "-",
        "COUNT": 2,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "염소산 나트륨",
        "IUPACNAME": "Sodium chlorate",
        "TRINAME": "Sodium chlorate(V)",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "NaClO3",
        "MOL_MASS": "106.45",
        "NFPA_R": "0",
        "NFPA_Y": "3",
        "NFPA_B": "2",
        "NFPA_W": "OX",
        "CAS number": "7775-09-09",
        "퍼센트": "98",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "시트르산 삼나트륨 2수화물",
        "IUPACNAME": "1,2,3-Propanetricarboxylic acid, 2-hydroxy-, trisodium salt, dihydrate",
        "TRINAME": "Sodium Citrate",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "Na3C6H5O7.2H2O",
        "MOL_MASS": "294.10",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "6132-04-03",
        "퍼센트": "98",
        "COUNT": 3,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "시트르산 삼나트륨 2수화물",
        "IUPACNAME": "1,2,3-Propanetricarboxylic acid, 2-hydroxy-, trisodium salt, dihydrate",
        "TRINAME": "Sodium Citrate",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "Na3C6H5O7.2H2O",
        "MOL_MASS": "294.10",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "6132-04-03",
        "퍼센트": "99",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "싸이오 황산 나트륨",
        "IUPACNAME": "Sodium thiosulfate",
        "TRINAME": "Sodium hyposulphite",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "Na2S2O3",
        "MOL_MASS": "158.11",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "7772-98-7",
        "퍼센트": "99",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "질산 나트륨",
        "IUPACNAME": "Sodium nitrate",
        "TRINAME": "Sodium Nitrate",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "NaNO3",
        "MOL_MASS": "84.99",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "OX",
        "CAS number": "7631-99-4",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "인산 이나트륨",
        "IUPACNAME": "Disodium hydrogen phosphate dodecahydrate",
        "TRINAME": "Sodium phosphate",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "Na2HPO4.12H2O",
        "MOL_MASS": "358.14",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "10039-32-4",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "싸이오시안 나트륨",
        "IUPACNAME": "Sodium thiocyanate",
        "TRINAME": "Sodium rhodanide",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "NaSCN",
        "MOL_MASS": "81.07",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "540-72-7",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "타타르산 나트륨",
        "IUPACNAME": "disodium (2R,3R)-2,3-dihydroxybutanedioate",
        "TRINAME": "Sodium Tartrate",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "Na2C4H4O6",
        "MOL_MASS": "230.09",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "6106-24-7",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "아자이드화 나트륨",
        "IUPACNAME": "Sodium azide",
        "TRINAME": "Sodium trinitride",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "NaN3",
        "MOL_MASS": "65.01",
        "NFPA_R": "1",
        "NFPA_Y": "3",
        "NFPA_B": "4",
        "NFPA_W": "-",
        "CAS number": "26628-22-8",
        "퍼센트": "99",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "수용성 전분",
        "IUPACNAME": "Starch, soluble",
        "TRINAME": "Starch, soluble",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "(C6H10O5)n",
        "MOL_MASS": "-",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "9005-25-8",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "염화 스트론튬 육수화물",
        "IUPACNAME": "Strontium chloride, hexahydrate",
        "TRINAME": "Strontium chloride hexahydrate",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "SrCl2.6H2O",
        "MOL_MASS": "266.62",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "10025-70-4",
        "퍼센트": "98",
        "COUNT": 2,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "수단 III",
        "IUPACNAME": "1-{[4-(Phenyldiazenyl)phenyl]diazenyl}naphthalen-2-ol",
        "TRINAME": "Sudan III",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C22H16N4O",
        "MOL_MASS": "352.40",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "85-86-9",
        "퍼센트": "-",
        "COUNT": 2,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "티몰 블루",
        "IUPACNAME": "3,3-Bis[4-hydroxy-2-methyl-5-(propan-2-yl)phenyl]-2,1λ6-benzoxathiole-1,1(3H)-dione",
        "TRINAME": "Thymol Blue",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C27H30O5S",
        "MOL_MASS": "466.60",
        "NFPA_R": "1",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "76-61-9",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "티몰프탈레인",
        "IUPACNAME": "3,3-Bis[4-hydroxy-2-methyl-5-(propan-2-yl)phenyl]-2-benzofuran-1(3H)-one",
        "TRINAME": "Thymolphthalein",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "C28H30O4",
        "MOL_MASS": "430.55",
        "NFPA_R": "0",
        "NFPA_Y": "0",
        "NFPA_B": "1",
        "NFPA_W": "-",
        "CAS number": "125-20-2",
        "퍼센트": "-",
        "COUNT": 1,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "만능지시약",
        "IUPACNAME": "Universal Indicator",
        "TRINAME": "Universal Indicator",
        "LOCATION": "2-4 하",
        "MOL_FORMULA": "-",
        "MOL_MASS": "-",
        "NFPA_R": "3",
        "NFPA_Y": "0",
        "NFPA_B": "2",
        "NFPA_W": "-",
        "CAS number": "-",
        "퍼센트": "-",
        "COUNT": 3,
        "총 시약 수": NaN
    },
    {
        "KORNAME": "해사",
        "IUPACNAME": "Sea sand",
        "TRINAME": "Quartz",
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "SiO₂",
        "MOL_MASS": "60.08 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "해사",
        "IUPACNAME": "Sea sand",
        "TRINAME": "Quartz",
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "SiO₂",
        "MOL_MASS": "60.08 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "브로민화칼륨",
        "IUPACNAME": "Potassium bromade",
        "TRINAME": "브롬칼리",
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "KBr",
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "흑연",
        "IUPACNAME": "Graphite powder",
        "TRINAME": "흑연 가루",
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "C",
        "MOL_MASS": "288.26 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "푸마르산",
        "IUPACNAME": "Fumaric acid",
        "TRINAME": "푸말산",
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "C4H4O4",
        "MOL_MASS": "116.07 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "철(II) 황화물",
        "IUPACNAME": "Ferrous Sulfide",
        "TRINAME": "황화철",
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "FeS",
        "MOL_MASS": "87.91 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "벤젠",
        "IUPACNAME": "Benzene",
        "TRINAME": "Benzol",
        "LOCATION": "3-1 하",
        "MOL_FORMULA": "C6H6",
        "MOL_MASS": "78.11 g/mol",
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "벤젠",
        "IUPACNAME": "Benzene",
        "TRINAME": "Benzol",
        "LOCATION": "3-1 하",
        "MOL_FORMULA": "C6H6",
        "MOL_MASS": "78.11 g/mol",
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "벤젠",
        "IUPACNAME": "Benzene",
        "TRINAME": "Benzol",
        "LOCATION": "3-1 하",
        "MOL_FORMULA": "C6H6",
        "MOL_MASS": "78.11 g/mol",
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "벤젠",
        "IUPACNAME": "Benzene",
        "TRINAME": "Benzol",
        "LOCATION": "3-1 하",
        "MOL_FORMULA": "C6H6",
        "MOL_MASS": "78.11 g/mol",
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "벤젠",
        "IUPACNAME": "Benzene",
        "TRINAME": "Benzol",
        "LOCATION": "3-1 하",
        "MOL_FORMULA": "C6H6",
        "MOL_MASS": "78.11 g/mol",
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "한천",
        "IUPACNAME": "Agar powder",
        "TRINAME": null,
        "LOCATION": "3-1 하",
        "MOL_FORMULA": "C14H24O9",
        "MOL_MASS": "336.33496 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "한천",
        "IUPACNAME": "Agar powder",
        "TRINAME": null,
        "LOCATION": "3-1 하",
        "MOL_FORMULA": "C14H24O9",
        "MOL_MASS": "336.33496 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "한천",
        "IUPACNAME": "Agar powder",
        "TRINAME": null,
        "LOCATION": "3-1 하",
        "MOL_FORMULA": "C14H24O9",
        "MOL_MASS": "336.33496 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "한천",
        "IUPACNAME": "Agar powder",
        "TRINAME": null,
        "LOCATION": "3-1 하",
        "MOL_FORMULA": "C14H24O9",
        "MOL_MASS": "336.33496 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": "LBagar,miller",
        "TRINAME": null,
        "LOCATION": "3-1 하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": "malt extract agar",
        "TRINAME": null,
        "LOCATION": "3-1 하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": "nutrient agar",
        "TRINAME": null,
        "LOCATION": "3-1 하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": "nutrient agar",
        "TRINAME": null,
        "LOCATION": "3-1 하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": "LAB-LEMCO agar",
        "TRINAME": null,
        "LOCATION": "3-1 하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "아가로오스",
        "IUPACNAME": "Agarose",
        "TRINAME": null,
        "LOCATION": "3-1 하",
        "MOL_FORMULA": "C10H15N3O3",
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "철(II) 황화물",
        "IUPACNAME": "Ferrous Sulfide",
        "TRINAME": "황화철",
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "FeS",
        "MOL_MASS": "87.91 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "철(II) 황화물",
        "IUPACNAME": "Ferrous Sulfide",
        "TRINAME": "황화철",
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "FeS",
        "MOL_MASS": "87.91 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "철(II) 황화물",
        "IUPACNAME": "Ferrous Sulfide",
        "TRINAME": "황화철",
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "FeS",
        "MOL_MASS": "87.91 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "철(II) 황화물",
        "IUPACNAME": "Ferrous Sulfide",
        "TRINAME": "황화철",
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "FeS",
        "MOL_MASS": "87.91 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "브로민화칼륨",
        "IUPACNAME": "Potassium bromade",
        "TRINAME": "브롬칼리",
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "KBr",
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화제이철무수물",
        "IUPACNAME": "Ferric Chloride anhydrous",
        "TRINAME": null,
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "FeCl3",
        "MOL_MASS": "162.2 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "브로민화칼륨",
        "IUPACNAME": "Potassium bromade",
        "TRINAME": "브롬칼리",
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "KBr",
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "철(II) 황화물",
        "IUPACNAME": "Ferrous Sulfide",
        "TRINAME": "황화철",
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "FeS",
        "MOL_MASS": null,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "벤젠",
        "IUPACNAME": "Benzene",
        "TRINAME": "Benzol",
        "LOCATION": "3-1 하",
        "MOL_FORMULA": "C6H6",
        "MOL_MASS": "78.11 g/mol",
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "철(II) 황화물",
        "IUPACNAME": "Ferrous Sulfide",
        "TRINAME": "황화철",
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "FeS",
        "MOL_MASS": "87.91 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "황산철(Ⅱ)",
        "IUPACNAME": "Ferroin solution",
        "TRINAME": null,
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "FeO4S",
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "황산철(Ⅱ)",
        "IUPACNAME": "Ferroin solution",
        "TRINAME": null,
        "LOCATION": "3-1 상",
        "MOL_FORMULA": "FeO4S",
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "헥사메틸렌다이아민",
        "IUPACNAME": "Hexane-1,6-diamine",
        "TRINAME": "Hexamethylenediamine",
        "LOCATION": "3-2상",
        "MOL_FORMULA": "C6H16N2",
        "MOL_MASS": 116.2,
        "NFPA_R": 2,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": "-",
        "CAS number": "124-09-04",
        "퍼센트": "-",
        "COUNT": 2.0
    },
    {
        "KORNAME": "염산",
        "IUPACNAME": "Chlorane",
        "TRINAME": "Hydrochloric acid",
        "LOCATION": "3-2 상",
        "MOL_FORMULA": "HCl",
        "MOL_MASS": 36.46,
        "NFPA_R": 0,
        "NFPA_Y": 1,
        "NFPA_B": 3,
        "NFPA_W": "ACID",
        "CAS number": "7647-01-0",
        "퍼센트": 36,
        "COUNT": 8.0
    },
    {
        "KORNAME": "염산",
        "IUPACNAME": "Chlorane",
        "TRINAME": "Hydrochloric acid solution",
        "LOCATION": "3-2 상",
        "MOL_FORMULA": "HCl",
        "MOL_MASS": 36.46,
        "NFPA_R": 0,
        "NFPA_Y": 1,
        "NFPA_B": 3,
        "NFPA_W": "ACID",
        "CAS number": "7647-01-0",
        "퍼센트": "0.1M",
        "COUNT": 1.0
    },
    {
        "KORNAME": "아이오딘",
        "IUPACNAME": "Iodine",
        "TRINAME": "Iod",
        "LOCATION": "3-2 상",
        "MOL_FORMULA": "I2",
        "MOL_MASS": 253.8,
        "NFPA_R": 1,
        "NFPA_Y": 1,
        "NFPA_B": 3,
        "NFPA_W": "-",
        "CAS number": "7553-56-2",
        "퍼센트": "-",
        "COUNT": 1.0
    },
    {
        "KORNAME": "2-나이트로벤즈알데하이드",
        "IUPACNAME": "2-Nitrobenzaldehyde",
        "TRINAME": "Nitrobenzaldehyde",
        "LOCATION": "3-2 상",
        "MOL_FORMULA": "C7H5NO3",
        "MOL_MASS": 151.12,
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "-",
        "CAS number": "552-89-6",
        "퍼센트": "-",
        "COUNT": 1.0
    },
    {
        "KORNAME": "니트로벤젠",
        "IUPACNAME": "Nitrobenzene",
        "TRINAME": "Nitrobenzol",
        "LOCATION": "3-2 상",
        "MOL_FORMULA": "C6H5NO2",
        "MOL_MASS": 123.11,
        "NFPA_R": 2,
        "NFPA_Y": 1,
        "NFPA_B": 3,
        "NFPA_W": "-",
        "CAS number": "98-95-3",
        "퍼센트": "-",
        "COUNT": 6.0
    },
    {
        "KORNAME": "4-나이트로페놀",
        "IUPACNAME": "4-Nitrophenol",
        "TRINAME": "p-Nitrophenol",
        "LOCATION": "3-2 상",
        "MOL_FORMULA": "C6H5NO3",
        "MOL_MASS": 139.11,
        "NFPA_R": 1,
        "NFPA_Y": 2,
        "NFPA_B": 3,
        "NFPA_W": "-",
        "CAS number": "100-02-7",
        "퍼센트": "-",
        "COUNT": 1.0
    },
    {
        "KORNAME": null,
        "IUPACNAME": null,
        "TRINAME": null,
        "LOCATION": null,
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": null,
        "NFPA_Y": null,
        "NFPA_B": null,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "레조르시놀",
        "IUPACNAME": "Benzene-1,3-diol",
        "TRINAME": "Resorcinol",
        "LOCATION": "3-2 하",
        "MOL_FORMULA": "C6H6O2",
        "MOL_MASS": 110.11,
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 3,
        "NFPA_W": "-",
        "CAS number": "108-46-3",
        "퍼센트": "-",
        "COUNT": 1.0
    },
    {
        "KORNAME": "양이온 계면활성제",
        "IUPACNAME": "-",
        "TRINAME": "Surfactant",
        "LOCATION": "3-2 하",
        "MOL_FORMULA": "-",
        "MOL_MASS": "-",
        "NFPA_R": "-",
        "NFPA_Y": "-",
        "NFPA_B": "-",
        "NFPA_W": "-",
        "CAS number": "-",
        "퍼센트": 99,
        "COUNT": 2.0
    },
    {
        "KORNAME": "음이온 계면활성제",
        "IUPACNAME": "-",
        "TRINAME": "Surfactant",
        "LOCATION": "3-2 하",
        "MOL_FORMULA": "-",
        "MOL_MASS": "-",
        "NFPA_R": "-",
        "NFPA_Y": "-",
        "NFPA_B": "-",
        "NFPA_W": "-",
        "CAS number": "-",
        "퍼센트": 99,
        "COUNT": 2.0
    },
    {
        "KORNAME": "이스트",
        "IUPACNAME": "-",
        "TRINAME": "Yeast, dry",
        "LOCATION": "3-2 하",
        "MOL_FORMULA": "-",
        "MOL_MASS": "-",
        "NFPA_R": "-",
        "NFPA_Y": "-",
        "NFPA_B": "-",
        "NFPA_W": "-",
        "CAS number": "8013-01-2",
        "퍼센트": "-",
        "COUNT": 1.0
    },
    {
        "KORNAME": "염화제이주석 5수화물 ",
        "IUPACNAME": NaN,
        "TRINAME": "Tin(IV) Chloride Pentahydrate",
        "LOCATION": NaN,
        "MOL_FORMULA": "SnCl4 5H2O",
        "MOL_MASS": 350.6,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": 0.98,
        "COUNT": 1.0
    },
    {
        "KORNAME": "트리메틸아민",
        "IUPACNAME": NaN,
        "TRINAME": "Trimethylamine",
        "LOCATION": NaN,
        "MOL_FORMULA": "(CH3)3N",
        "MOL_MASS": 59.11,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": "75-50-3",
        "퍼센트": 0.3,
        "COUNT": 1.0
    },
    {
        "KORNAME": "지르코늄 옥시수화물 8수화물",
        "IUPACNAME": NaN,
        "TRINAME": "Zirconium(IV) chloride oxide octahydrate",
        "LOCATION": NaN,
        "MOL_FORMULA": "ZrCl2) 8H2O",
        "MOL_MASS": 322.25,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": "13520-92-8",
        "퍼센트": 0.9,
        "COUNT": 1.0
    },
    {
        "KORNAME": "실리카겔, 청색",
        "IUPACNAME": NaN,
        "TRINAME": "Silicagel Blue",
        "LOCATION": NaN,
        "MOL_FORMULA": "SiO2",
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": "7631-86-9",
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "시너스 실리콘",
        "IUPACNAME": NaN,
        "TRINAME": "Xinus Silicone",
        "LOCATION": NaN,
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": null,
        "COUNT": 7.0
    },
    {
        "KORNAME": "산화 니켈",
        "IUPACNAME": NaN,
        "TRINAME": "Nickel(II) Oxide",
        "LOCATION": NaN,
        "MOL_FORMULA": "NiO",
        "MOL_MASS": 74.69,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": 0.75,
        "COUNT": 1.0
    },
    {
        "KORNAME": "염화코발트(II) 6수화물",
        "IUPACNAME": NaN,
        "TRINAME": "Cobalt(II) Chloride HexaHydrate",
        "LOCATION": NaN,
        "MOL_FORMULA": "CoCl2 6H2O",
        "MOL_MASS": 237.93,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": null,
        "COUNT": 1.0
    },
    {
        "KORNAME": "실리카(이산화 규소)",
        "IUPACNAME": NaN,
        "TRINAME": "Silica",
        "LOCATION": NaN,
        "MOL_FORMULA": "O2Si",
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": "7631-86-9",
        "퍼센트": 0.998,
        "COUNT": NaN
    },
    {
        "KORNAME": "타닌산",
        "IUPACNAME": NaN,
        "TRINAME": "Tannic Acid",
        "LOCATION": NaN,
        "MOL_FORMULA": "C76H52O46",
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": "1401-55-4",
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "디메틸글리옥심",
        "IUPACNAME": NaN,
        "TRINAME": "Dimethylglyoxime",
        "LOCATION": NaN,
        "MOL_FORMULA": "(CH3)2C2(NOH)2",
        "MOL_MASS": 116.12,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": "초산니켈 4수화물",
        "IUPACNAME": NaN,
        "TRINAME": "Nickel(II) acetate tetrahydrate",
        "LOCATION": NaN,
        "MOL_FORMULA": "(CH3COO)2Ni 4H2O",
        "MOL_MASS": 248.84,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": "6018-89-9",
        "퍼센트": 0.98,
        "COUNT": NaN
    },
    {
        "KORNAME": "디클로로메테인",
        "IUPACNAME": NaN,
        "TRINAME": "Dichloromethane",
        "LOCATION": NaN,
        "MOL_FORMULA": "CH2Cl2",
        "MOL_MASS": 84.93,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": 0.995,
        "COUNT": NaN
    },
    {
        "KORNAME": "염화제일철 4수화물",
        "IUPACNAME": NaN,
        "TRINAME": "Iron(II) chloride tetrahydrate",
        "LOCATION": NaN,
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": 0.99,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": null,
        "LOCATION": NaN,
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": null,
        "LOCATION": NaN,
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": "Silicagel Blue",
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": null,
        "LOCATION": NaN,
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": "' medium granular",
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": null,
        "LOCATION": NaN,
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": null,
        "퍼센트": " ",
        "COUNT": NaN
    },
    {
        "KORNAME": "살리실산",
        "IUPACNAME": NaN,
        "TRINAME": "salicylic acid",
        "LOCATION": "3-4 상",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": "-",
        "COUNT": 3.0,
        "Unnamed: 13": 20.0
    },
    {
        "KORNAME": "자당",
        "IUPACNAME": NaN,
        "TRINAME": "saccharose",
        "LOCATION": "3-4 상",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "나프탈렌",
        "IUPACNAME": NaN,
        "TRINAME": "Naphthalene",
        "LOCATION": "3-4 상",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": 4.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "염화 니켈 6수화물",
        "IUPACNAME": NaN,
        "TRINAME": "Nickel Chloride",
        "LOCATION": "3-4 상",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 96,
        "COUNT": 2.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "살리실산",
        "IUPACNAME": NaN,
        "TRINAME": "salicylic acid",
        "LOCATION": "3-4 상",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 99.5,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "염화 니켈 6수화물",
        "IUPACNAME": NaN,
        "TRINAME": "Nickel Chloride",
        "LOCATION": "3-4 상",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 97,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "붕사",
        "IUPACNAME": NaN,
        "TRINAME": "Sodium Borax",
        "LOCATION": "3-4 상",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": 2.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "붕산 나트륨 10수화물",
        "IUPACNAME": NaN,
        "TRINAME": "Sodium tetraborate decahydrate",
        "LOCATION": "3-4 상",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 101,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "Stearic Acid",
        "LOCATION": "3-4 상",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": 2.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "nickel(II) Nitrate Hexahydrate",
        "LOCATION": "3-4 상",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "nickel(II) Sulfate Hexahydrate",
        "LOCATION": "3-4 상",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "Sodium tetraborate decahydrate",
        "LOCATION": "3-4 상",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": null,
        "LOCATION": null,
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": NaN,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "Ammonium Thiocyanate",
        "LOCATION": "3-4 하",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 99,
        "COUNT": 1.0,
        "Unnamed: 13": 21.0
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "Ammonium Thiocyanate",
        "LOCATION": "3-4 하",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 99.5,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "Sodium Dichromate solution",
        "LOCATION": "3-4 하",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": "0.1M",
        "COUNT": 4.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "Ammonium acetate basic n-hydrate",
        "LOCATION": "3-4 하",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 13,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "Sodium Dichromate dihydrate",
        "LOCATION": "3-4 하",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 99,
        "COUNT": 4.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "Ammonium Dichromate",
        "LOCATION": "3-4 하",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": null,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "Aluminium nitrate nonahydrate",
        "LOCATION": "3-4 하",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 98,
        "COUNT": 2.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "Sodium Acetate Trihydrate",
        "LOCATION": "3-4 하",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 98.5,
        "COUNT": 3.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "Ammonium Carbonate",
        "LOCATION": "3-4 하",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 20,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "Ammonium Phosphate monobasic",
        "LOCATION": "3-4 하",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 98,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "Ammonium Iron(II) Sulfate Hexahydrate",
        "LOCATION": "3-4 하",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 98,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": NaN,
        "TRINAME": "Ammonium Sulfate",
        "LOCATION": "3-4 하",
        "MOL_FORMULA": NaN,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": NaN,
        "CAS number": NaN,
        "퍼센트": 99,
        "COUNT": 1.0,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "젤라틴",
        "IUPACNAME": "Gelatin",
        "TRINAME": null,
        "LOCATION": "4-1 상",
        "MOL_FORMULA": "C6H12O6",
        "MOL_MASS": 10000.0,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "9000-70-8",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Gelatin",
        "TRINAME": null,
        "LOCATION": "4-1 상",
        "MOL_FORMULA": "C6H12O6",
        "MOL_MASS": 10000.0,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "9000-70-8",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "물금속검사",
        "IUPACNAME": "water metals check",
        "TRINAME": null,
        "LOCATION": "4-1 상",
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "무수크롬(VI)",
        "IUPACNAME": "Chromium(VI) Oxide",
        "TRINAME": "Chromium Trioxide",
        "LOCATION": "4-1 상",
        "MOL_FORMULA": "CrO3",
        "MOL_MASS": 99.99,
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 4.0,
        "NFPA_W": "OX",
        "CAS number": "1333-82-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Pb 1000",
        "TRINAME": null,
        "LOCATION": "4-1 상",
        "MOL_FORMULA": "Pb",
        "MOL_MASS": 207.2,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": null,
        "CAS number": "7439-92-1",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Ag 1000",
        "TRINAME": null,
        "LOCATION": "4-1 상",
        "MOL_FORMULA": "Ag",
        "MOL_MASS": 107.868,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": null,
        "CAS number": "7440-22-4",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "금속 코발트",
        "IUPACNAME": "Cobalt Metal",
        "TRINAME": null,
        "LOCATION": "4-1 상",
        "MOL_FORMULA": "Co",
        "MOL_MASS": 59.0,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": null,
        "CAS number": "7440-48-4",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "NP-600",
        "IUPACNAME": "NP-600",
        "TRINAME": null,
        "LOCATION": "4-1 상",
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "이소프로판올",
        "IUPACNAME": "2-Propanol",
        "TRINAME": "Isopropyl alcohol",
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "(CH3)2CHOH",
        "MOL_MASS": 60.1,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "67-63-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "이소프로판올",
        "IUPACNAME": "2-Propanol",
        "TRINAME": "Isopropyl alcohol",
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "(CH3)2CHOH",
        "MOL_MASS": 60.1,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "67-63-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "이소프로판올",
        "IUPACNAME": "2-Propanol",
        "TRINAME": "Isopropyl alcohol",
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "(CH3)2CHOH",
        "MOL_MASS": 60.1,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "67-63-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "이소프로판올",
        "IUPACNAME": "2-Propanol",
        "TRINAME": "Isopropyl alcohol",
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "(CH3)2CHOH",
        "MOL_MASS": 60.1,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "67-63-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "이소프로판올",
        "IUPACNAME": "2-Propanol",
        "TRINAME": "Isopropyl alcohol",
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "(CH3)2CHOH",
        "MOL_MASS": 60.1,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "67-63-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "시트르산(구연산) 1수화물",
        "IUPACNAME": "Citric Acid, Monohydrate",
        "TRINAME": "tricarboxylic acid",
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "HOOCCH2C(OH)(COOH)CH2COOH * H2O",
        "MOL_MASS": 210.15,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": null,
        "CAS number": "5949-29-1",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "시트르산(구연산) 1수화물",
        "IUPACNAME": "Citric Acid, Monohydrate",
        "TRINAME": "tricarboxylic acid",
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "HOOCCH2C(OH)(COOH)CH2COOH * H2O",
        "MOL_MASS": 210.15,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": null,
        "CAS number": "5949-29-1",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "시트르산(구연산)",
        "IUPACNAME": "Citric Acid",
        "TRINAME": "tricarboxylic acid",
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "HOOCCH2C(OH)(COOH)CH2COOH",
        "MOL_MASS": 210.15,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": null,
        "CAS number": "77-92-9",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "이미다졸",
        "IUPACNAME": "Imidazole, 99.0%",
        "TRINAME": "Glyoxaline",
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "C3H4N2",
        "MOL_MASS": 68.08,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 3.0,
        "NFPA_W": null,
        "CAS number": "288-32-4",
        "퍼센트": 0.99,
        "COUNT": NaN
    },
    {
        "KORNAME": "요오드",
        "IUPACNAME": "Iodine, I",
        "TRINAME": null,
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "I",
        "MOL_MASS": 126.9,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 3.0,
        "NFPA_W": null,
        "CAS number": "7553-56-2",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "제올라이트",
        "IUPACNAME": "Zeolite, Synthetic, A-3, Beads, 1.40~2.36mm(8~12mesh)",
        "TRINAME": null,
        "LOCATION": "4-1 하",
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": null,
        "CAS number": "1318-02-1",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "EBT 지시약",
        "IUPACNAME": "Eriochrom Black T, Solution",
        "TRINAME": null,
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "C20H12O7N3SNa",
        "MOL_MASS": NaN,
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "1787-61-7",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "셀레늄 가루",
        "IUPACNAME": "Selenium, powder, 99+%",
        "TRINAME": null,
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "Se",
        "MOL_MASS": 78.97,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 3.0,
        "NFPA_W": null,
        "CAS number": "7782-49-2",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "클로로폼",
        "IUPACNAME": "Chloroform",
        "TRINAME": "Trichloromethane",
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "CHCl3",
        "MOL_MASS": 119.38,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": null,
        "CAS number": "67-66-3",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "철가루",
        "IUPACNAME": "Iron, powder",
        "TRINAME": null,
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "Fe",
        "MOL_MASS": 55.85,
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": null,
        "CAS number": "7439-89-6",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "철가루",
        "IUPACNAME": "Iron, powder",
        "TRINAME": null,
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "Fe",
        "MOL_MASS": 55.85,
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": null,
        "CAS number": "7439-89-6",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "1-프로판올",
        "IUPACNAME": "1-Propanol",
        "TRINAME": "Propyl alcohol",
        "LOCATION": "4-1 하",
        "MOL_FORMULA": "CH3CH2CH2OH",
        "MOL_MASS": 60.1,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "71-23-8",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "에데트산나트륨",
        "IUPACNAME": "Ethylenediaminetetraacetic acid disodium salt dihydrate",
        "TRINAME": "Disodium ethylenediaminetetraacetate dihydrate",
        "LOCATION": "4-2(상)",
        "MOL_FORMULA": "C10H14N2Na2O8 · 2H2O",
        "MOL_MASS": "372.24g/mol",
        "NFPA_B": 1.0,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_W": null,
        "CAS number": "         6381-92-6",
        "퍼센트": 0.995,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "락트산",
        "IUPACNAME": "2-hydroxypropanoic acid",
        "TRINAME": "Lactic Acid",
        "LOCATION": "4-2(상)",
        "MOL_FORMULA": "CH3CH(OH)COOH",
        "MOL_MASS": "90.08g/mol",
        "NFPA_B": 2.0,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_W": null,
        "CAS number": "50-21-5",
        "퍼센트": 0.875,
        "COUNT": 3.0,
        "Unnamed: 13": 3.0
    },
    {
        "KORNAME": "유당2수화물",
        "IUPACNAME": "β-D-galactopyranosyl-(1→4)-D-glucose-Monohydrate",
        "TRINAME": "Lactobiose-Monohydrate",
        "LOCATION": "4-2(상)",
        "MOL_FORMULA": "C12H22O11-H2O",
        "MOL_MASS": "360.31g/mol",
        "NFPA_B": 0.0,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_W": null,
        "CAS number": "       64044-51-5",
        "퍼센트": NaN,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "라우르산",
        "IUPACNAME": "Dodecanoic acid",
        "TRINAME": "Lauric acid",
        "LOCATION": "4-2(상)",
        "MOL_FORMULA": "CH3(CH2)10COOH",
        "MOL_MASS": "200.32g/mol",
        "NFPA_B": 1.0,
        "NFPA_R": 1.0,
        "NFPA_Y": 1.0,
        "NFPA_W": null,
        "CAS number": "0143-07-07",
        "퍼센트": NaN,
        "COUNT": 3.0,
        "Unnamed: 13": 3.0
    },
    {
        "KORNAME": "산화납",
        "IUPACNAME": "Lead(II) oxide",
        "TRINAME": "Lead monoxide",
        "LOCATION": "4-2(상)",
        "MOL_FORMULA": "PbO",
        "MOL_MASS": "223.21g/mol",
        "NFPA_B": 3.0,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_W": null,
        "CAS number": "         1317-36-8",
        "퍼센트": 0.98,
        "COUNT": 2.0,
        "Unnamed: 13": 2.0
    },
    {
        "KORNAME": "아세트산 납(IV)",
        "IUPACNAME": "Lead(IV) acetate",
        "TRINAME": "Lead tetraacetate",
        "LOCATION": "4-2(상)",
        "MOL_FORMULA": "Pb(C2H3O2)4",
        "MOL_MASS": "443.376g/mol",
        "NFPA_B": 3.0,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_W": null,
        "CAS number": "546-67-8",
        "퍼센트": 0.95,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "질산납",
        "IUPACNAME": "Lead(II) nitrate",
        "TRINAME": "LeadNitrateAr",
        "LOCATION": "4-2(상)",
        "MOL_FORMULA": "Pb(NO3)2",
        "MOL_MASS": "331.21g/mol",
        "NFPA_B": 3.0,
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_W": "OX",
        "CAS number": "       10099-74-8",
        "퍼센트": 0.99,
        "COUNT": 2.0,
        "Unnamed: 13": 2.0
    },
    {
        "KORNAME": "질산납(용액)",
        "IUPACNAME": "Lead(II) nitrate",
        "TRINAME": "LeadNitrateAr(solution)",
        "LOCATION": "4-2(상)",
        "MOL_FORMULA": "Pb(NO3)2",
        "MOL_MASS": "331.21g/mol",
        "NFPA_B": 3.0,
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_W": "OX",
        "CAS number": "       10099-74-8",
        "퍼센트": 0.99,
        "COUNT": 2.0,
        "Unnamed: 13": 2.0
    },
    {
        "KORNAME": "리튬",
        "IUPACNAME": "Lithium",
        "TRINAME": "Lithium",
        "LOCATION": "4-2(상)",
        "MOL_FORMULA": "Li",
        "MOL_MASS": " 6.941g/mol",
        "NFPA_B": 1.0,
        "NFPA_R": 3.0,
        "NFPA_Y": 2.0,
        "NFPA_W": "W",
        "CAS number": "         7439-93-2",
        "퍼센트": 0.99,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "리튬 막대",
        "IUPACNAME": "Lithium",
        "TRINAME": "Lithium",
        "LOCATION": "4-2(상)",
        "MOL_FORMULA": "Li",
        "MOL_MASS": "6.941g/mol",
        "NFPA_B": 1.0,
        "NFPA_R": 3.0,
        "NFPA_Y": 2.0,
        "NFPA_W": "W",
        "CAS number": "         7439-93-2",
        "퍼센트": 1.0,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "아세트산 납 삼수화물",
        "IUPACNAME": "Lead(II) acetate trihydrate",
        "TRINAME": "Sugar of Lead trihydrate",
        "LOCATION": "4-2(상)",
        "MOL_FORMULA": "Pb(CH3COO)2-3H2O",
        "MOL_MASS": "379.35g/mol",
        "NFPA_B": 3.0,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_W": null,
        "CAS number": "         6080-56-4",
        "퍼센트": 0.99,
        "COUNT": 3.0,
        "Unnamed: 13": 3.0
    },
    {
        "KORNAME": null,
        "IUPACNAME": null,
        "TRINAME": null,
        "LOCATION": null,
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_B": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": NaN
    },
    {
        "KORNAME": "부틸 알코올",
        "IUPACNAME": "n-Butyl Alcohol",
        "TRINAME": " Butyl Alcohol",
        "LOCATION": "4-2(하)",
        "MOL_FORMULA": "C4H10O",
        "MOL_MASS": "74.12g/mol",
        "NFPA_B": 1.0,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_W": null,
        "CAS number": "             71-36-3",
        "퍼센트": 0.99,
        "COUNT": 4.0,
        "Unnamed: 13": 4.0
    },
    {
        "KORNAME": "질산",
        "IUPACNAME": "Nitric acid",
        "TRINAME": "Hydrogen nitrate",
        "LOCATION": "4-2(하)",
        "MOL_FORMULA": "HNO3",
        "MOL_MASS": "63.01g/mol",
        "NFPA_B": 2.0,
        "NFPA_R": 4.0,
        "NFPA_Y": 0.0,
        "NFPA_W": "OX",
        "CAS number": "         7692-37-2",
        "퍼센트": 0.605,
        "COUNT": 6.0,
        "Unnamed: 13": 6.0
    },
    {
        "KORNAME": "질산-60%",
        "IUPACNAME": "Nitric acid",
        "TRINAME": "Hydrogen nitrate",
        "LOCATION": "4-2(하)",
        "MOL_FORMULA": "HNO3",
        "MOL_MASS": "63.01g/mol",
        "NFPA_B": 2.0,
        "NFPA_R": 4.0,
        "NFPA_Y": 0.0,
        "NFPA_W": "OX",
        "CAS number": "         7697-37-2",
        "퍼센트": 0.615,
        "COUNT": 3.0,
        "Unnamed: 13": 3.0
    },
    {
        "KORNAME": "염화리튬",
        "IUPACNAME": "Lithium Chloride",
        "TRINAME": "Lithium(1+) Chloride",
        "LOCATION": "4-2(하)",
        "MOL_FORMULA": "LiCl",
        "MOL_MASS": "42.39g/mol",
        "NFPA_B": 2.0,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_W": null,
        "CAS number": "7447-41-8",
        "퍼센트": 0.98,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "m-크레졸",
        "IUPACNAME": "3-methylphenol",
        "TRINAME": "m-Cresol",
        "LOCATION": "4-2(하)",
        "MOL_FORMULA": "CH3C6H4OH",
        "MOL_MASS": "108.14g/mol",
        "NFPA_B": 3.0,
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_W": null,
        "CAS number": "           108-39-4",
        "퍼센트": NaN,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "n-프로필 알코올",
        "IUPACNAME": "n-Propyl Alcohol",
        "TRINAME": "n-Propanol",
        "LOCATION": "4-2(하)",
        "MOL_FORMULA": "CH3CH2CH2OH",
        "MOL_MASS": "60.1g/mol",
        "NFPA_B": 1.0,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_W": null,
        "CAS number": "             71-23-8",
        "퍼센트": NaN,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "질산은 0.1M",
        "IUPACNAME": "N/10-Silver nitrate",
        "TRINAME": "N/10-Lapis infernalis",
        "LOCATION": "4-2(하)",
        "MOL_FORMULA": "N/10-AgNO3",
        "MOL_MASS": "169.872g/mol",
        "NFPA_B": 2.0,
        "NFPA_R": 0.0,
        "NFPA_Y": 3.0,
        "NFPA_W": "OX",
        "CAS number": "         7761-88-8",
        "퍼센트": NaN,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "삼차 부틸 알코올 ",
        "IUPACNAME": "2-Methylpropan-2-ol",
        "TRINAME": "Tert-Butanol",
        "LOCATION": "4-2(하)",
        "MOL_FORMULA": "C4H10O",
        "MOL_MASS": "74.12g/mol",
        "NFPA_B": 1.0,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_W": null,
        "CAS number": "             75-65-0",
        "퍼센트": 0.995,
        "COUNT": 5.0,
        "Unnamed: 13": 5.0
    },
    {
        "KORNAME": "삼차 부틸 알코올 ",
        "IUPACNAME": "2-Methylpropan-2-ol",
        "TRINAME": "Tert-Butanol",
        "LOCATION": "4-2(하)",
        "MOL_FORMULA": "C4H10O",
        "MOL_MASS": "74.12g/mol",
        "NFPA_B": 1.0,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_W": null,
        "CAS number": "             75-65-0",
        "퍼센트": 0.99,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "테트라에틸 오르토실리케이트",
        "IUPACNAME": "Tetraethyl orthosilicate",
        "TRINAME": "Tetra-; silicic acid tetraethyl ester",
        "LOCATION": "4-2(하)",
        "MOL_FORMULA": "C8H20O4Si",
        "MOL_MASS": "208.33g/mol",
        "NFPA_B": 2.0,
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_W": null,
        "CAS number": "78-10-4",
        "퍼센트": 0.99,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "이산화 타이타늄",
        "IUPACNAME": "Titanium(IV) oxide",
        "TRINAME": "Titania,rutil form",
        "LOCATION": "4-2(하)",
        "MOL_FORMULA": "TiO2",
        "MOL_MASS": "79.88g/mol",
        "NFPA_B": 1.0,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_W": null,
        "CAS number": "13463-67-7",
        "퍼센트": 0.99,
        "COUNT": 1.0,
        "Unnamed: 13": 1.0
    },
    {
        "KORNAME": "아세트알데하이드",
        "IUPACNAME": "Acetaldehyde",
        "TRINAME": "Ethanal",
        "LOCATION": "4-3 상",
        "MOL_FORMULA": "C2H4O",
        "MOL_MASS": 44.053,
        "NFPA_R": 4.0,
        "NFPA_Y": 3.0,
        "NFPA_B": 3.0,
        "NFPA_W": "-",
        "CAS number": "75-07-0",
        "퍼센트": 90.0,
        "COUNT": 2.0
    },
    {
        "KORNAME": "아세트산",
        "IUPACNAME": "Acetic acid",
        "TRINAME": "Ethanoic acid",
        "LOCATION": "4-3 상",
        "MOL_FORMULA": "CH3COOH",
        "MOL_MASS": 60.052,
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 3.0,
        "NFPA_W": "-",
        "CAS number": "64-19-7",
        "퍼센트": 99.5,
        "COUNT": 1.0
    },
    {
        "KORNAME": "황산알루미늄암모늄 12수화물",
        "IUPACNAME": "Aluminum azanium disulfate dodecahydrate",
        "TRINAME": "Aluminium Ammonium Sulfate dodecahydrate",
        "LOCATION": "4-3 상",
        "MOL_FORMULA": "AlNH4(SO4)2 · 12H2O",
        "MOL_MASS": 453.33,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "7784-26-1",
        "퍼센트": 99.0,
        "COUNT": 2.0
    },
    {
        "KORNAME": "산화 알루미늄",
        "IUPACNAME": "Aluminum Oxide",
        "TRINAME": "Aluminuim Oxide",
        "LOCATION": "4-3 상",
        "MOL_FORMULA": "Al2O3",
        "MOL_MASS": 101.96,
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 0.0,
        "NFPA_W": "-",
        "CAS number": "1344-28-1",
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": null,
        "IUPACNAME": null,
        "TRINAME": null,
        "LOCATION": null,
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "황산 카드뮴 n수화물",
        "IUPACNAME": "Cadmium Sulfate n Hydrate",
        "TRINAME": "Cadmium Sulfate n Hydrate",
        "LOCATION": "4-3 하",
        "MOL_FORMULA": "CdSO4 · nH2O",
        "MOL_MASS": 208.47,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "15244-35-6",
        "퍼센트": 99.0,
        "COUNT": 2.0
    },
    {
        "KORNAME": "황산 코발트 7수화물",
        "IUPACNAME": "Cobalt(II) Sulfate Heptahydrate",
        "TRINAME": "Cobalt(II) Sulfate Heptahydrate",
        "LOCATION": "4-3 하",
        "MOL_FORMULA": "CoSO4 · 7H2O",
        "MOL_MASS": 281.1,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "10026-24-1",
        "퍼센트": 98.0,
        "COUNT": 3.0
    },
    {
        "KORNAME": "플루오르화 칼슘",
        "IUPACNAME": "Calcium difluoride",
        "TRINAME": "Calcium Fluoride",
        "LOCATION": "4-3 하",
        "MOL_FORMULA": "CaF₂",
        "MOL_MASS": 78.07,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "7789-75-5",
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "제이 인산 칼륨 3수화물",
        "IUPACNAME": "Potassium dihydrogen phosphate trihydrate",
        "TRINAME": "di-Potassium hydrogen phosphate trihydrate",
        "LOCATION": "4-3 하",
        "MOL_FORMULA": "HK2O4P · 3H2O",
        "MOL_MASS": 228.22,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "16788-57-1",
        "퍼센트": 99.0,
        "COUNT": 1.0
    },
    {
        "KORNAME": "수소인산 나트륨 2수화물",
        "IUPACNAME": "Sodium dihydrogen phosphate dihydrate",
        "TRINAME": "Sodium Phosphate Monobasic dihydrate",
        "LOCATION": "4-3 하",
        "MOL_FORMULA": "NaH2PO4 · 2H2O",
        "MOL_MASS": 156.01,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "231-449-2",
        "퍼센트": 98.0,
        "COUNT": 1.0
    },
    {
        "KORNAME": "수소인산 나트륨 무수화물",
        "IUPACNAME": "sodium dihydrogen phosphate",
        "TRINAME": "Sodium Phosphate Monobasic anhydrous",
        "LOCATION": "4-3 하",
        "MOL_FORMULA": "NaH2PO4",
        "MOL_MASS": 119.98,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "7558-80-7",
        "퍼센트": 98.0,
        "COUNT": 1.0
    },
    {
        "KORNAME": "차아염소산칼슘",
        "IUPACNAME": "Calcium hypochlorite",
        "TRINAME": "Chlorinated Lime",
        "LOCATION": "4-3 하",
        "MOL_FORMULA": "Ca(ClO)₂",
        "MOL_MASS": 142.98,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "7778-54-3",
        "퍼센트": 60.0,
        "COUNT": 1.0
    },
    {
        "KORNAME": "제이염화구리 2수화물",
        "IUPACNAME": "Copper dichloride dihydrate",
        "TRINAME": "Copper(II) chloride dihydrate",
        "LOCATION": "4-3 하",
        "MOL_FORMULA": "CuCl2 · 2H2O",
        "MOL_MASS": 170.48,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "10125-13-0",
        "퍼센트": 97.5,
        "COUNT": 1.0
    },
    {
        "KORNAME": "염기성 탄산동",
        "IUPACNAME": "Dicopper carbonate dihydroxide",
        "TRINAME": "Copper(II) Carbonate Basic",
        "LOCATION": "4-3 하",
        "MOL_FORMULA": "CH2Cu2O5",
        "MOL_MASS": 221.11,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "12069-69-1",
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "질산 나트륨",
        "IUPACNAME": "Sodium Nitrate",
        "TRINAME": "Sodium Nitrate",
        "LOCATION": "4-3 하",
        "MOL_FORMULA": "NaNO3",
        "MOL_MASS": 84.9947,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "7631-99-4",
        "퍼센트": 98.0,
        "COUNT": 1.0
    },
    {
        "KORNAME": "제이 황산 구리 5수화물",
        "IUPACNAME": "Copper pentahydrate sulfate",
        "TRINAME": "Copper(II) Sulfate Pentahydrate",
        "LOCATION": "4-3 하",
        "MOL_FORMULA": "CuSO4 · 5H2O",
        "MOL_MASS": 249.69,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "7758-99-8",
        "퍼센트": 99.0,
        "COUNT": 1.0
    },
    {
        "KORNAME": null,
        "IUPACNAME": "x",
        "TRINAME": null,
        "LOCATION": null,
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "칼륨",
        "IUPACNAME": "Potassium",
        "TRINAME": "Potassium",
        "LOCATION": "4-4(상)",
        "MOL_FORMULA": "K",
        "MOL_MASS": "38.0983 g/mol",
        "NFPA_R": 3.0,
        "NFPA_Y": 2.0,
        "NFPA_B": 3.0,
        "NFPA_W": "W",
        "CAS number": null,
        "퍼센트": 0.995,
        "COUNT": 1.0,
        "Unnamed: 13": 1,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "과염소산 칼륨",
        "IUPACNAME": "Potassium Perchlorate",
        "TRINAME": "Potassium Perchlorate",
        "LOCATION": "4-4(상)",
        "MOL_FORMULA": "KClO4",
        "MOL_MASS": "138.55 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 1.0,
        "NFPA_W": "OX",
        "CAS number": null,
        "퍼센트": 0.99,
        "COUNT": 1.0,
        "Unnamed: 13": 1,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "중크롬산 칼륨",
        "IUPACNAME": "Potassium Dichromate",
        "TRINAME": "Potassium Dichromate",
        "LOCATION": "4-4(상)",
        "MOL_FORMULA": "K2Cr2O7",
        "MOL_MASS": "294.21 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 4.0,
        "NFPA_W": "OX",
        "CAS number": null,
        "퍼센트": 0.995,
        "COUNT": 3.0,
        "Unnamed: 13": 3,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "중크롬산 칼륨",
        "IUPACNAME": "Potassium Dichromate",
        "TRINAME": "Potassium Dichromate",
        "LOCATION": "4-4(상)",
        "MOL_FORMULA": "K2Cr2O7",
        "MOL_MASS": "294.18 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 4.0,
        "NFPA_W": "OX",
        "CAS number": null,
        "퍼센트": 0.99,
        "COUNT": NaN,
        "Unnamed: 13": 2,
        "Unnamed: 14": "1개 - 미상"
    },
    {
        "KORNAME": "염화 칼륨",
        "IUPACNAME": "Potassium Chlorate",
        "TRINAME": "Potassium Chlorate",
        "LOCATION": "4-4(상)",
        "MOL_FORMULA": "KClO3",
        "MOL_MASS": "122.55 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 3.0,
        "NFPA_B": 2.0,
        "NFPA_W": "OX",
        "CAS number": null,
        "퍼센트": 0.995,
        "COUNT": NaN,
        "Unnamed: 13": 2,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "염화 칼륨",
        "IUPACNAME": "Potassium Chlorate",
        "TRINAME": "Potassium Chlorate",
        "LOCATION": "4-4(상)",
        "MOL_FORMULA": "KClO3",
        "MOL_MASS": "122.55 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 3.0,
        "NFPA_B": 2.0,
        "NFPA_W": "OX",
        "CAS number": null,
        "퍼센트": 0.99,
        "COUNT": NaN,
        "Unnamed: 13": 1,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "티오시안화 칼륨",
        "IUPACNAME": "Potassium Thiocyanate",
        "TRINAME": "Potassium Thiocyanate",
        "LOCATION": "4-4(상)",
        "MOL_FORMULA": "KSCN",
        "MOL_MASS": "97.18 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": "x",
        "CAS number": null,
        "퍼센트": 0.99,
        "COUNT": 2.0,
        "Unnamed: 13": 2,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "미네랄 오일",
        "IUPACNAME": "Mineral Oil (Heavy)",
        "TRINAME": "Mineral Oil (Heavy)",
        "LOCATION": "4-4(상)",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": null,
        "COUNT": NaN,
        "Unnamed: 13": 1,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "파라핀(고체)",
        "IUPACNAME": "Paraffin",
        "TRINAME": "Paraffin",
        "LOCATION": "4-4(상)",
        "MOL_FORMULA": "CnH(2n+2)  (n≥19)",
        "MOL_MASS": null,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "x",
        "CAS number": "8002-74-2",
        "퍼센트": null,
        "COUNT": 1.0,
        "Unnamed: 13": 1,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "파라핀(액체)",
        "IUPACNAME": "Paraffin Liquid",
        "TRINAME": "Paraffin Liquid",
        "LOCATION": "4-4(상)",
        "MOL_FORMULA": "CnH(2n+2)  (n≥19)",
        "MOL_MASS": null,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": "x",
        "CAS number": "8012-95-1",
        "퍼센트": null,
        "COUNT": 2.0,
        "Unnamed: 13": 2,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "타르타르산(주석산) 나트륨 칼륨 4수화물",
        "IUPACNAME": "Potassium Sodium Tartrate Tetrahydrate",
        "TRINAME": "Potassium Sodium Tartrate Tetrahydrate",
        "LOCATION": "4-4(상)",
        "MOL_FORMULA": "C4H4KNaO6 . 4H2O",
        "MOL_MASS": "282.22 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": 0.99,
        "COUNT": 3.0,
        "Unnamed: 13": 3,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "타르타르산(주석산) 나트륨 칼륨 0.5수화물",
        "IUPACNAME": "Potassium Sodium Tartrate 0.5-hydrate",
        "TRINAME": "Potassium Sodium Tartrate 0.5-hydrate",
        "LOCATION": "4-4(상)",
        "MOL_FORMULA": "C4H4KNaO6 . 1/2H2O",
        "MOL_MASS": "235.28 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": 0.99,
        "COUNT": NaN,
        "Unnamed: 13": 1,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "크롬산 칼륨",
        "IUPACNAME": "Potassium Chromate",
        "TRINAME": "Potassium Chromate",
        "LOCATION": "4-4(상)",
        "MOL_FORMULA": "K2CrO4",
        "MOL_MASS": "194.21 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": 0.985,
        "COUNT": 1.0,
        "Unnamed: 13": 1,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "브롬화 칼륨 용액",
        "IUPACNAME": "Potassium Bromide",
        "TRINAME": "Potassium Bromide Solution",
        "LOCATION": "4-4(하)",
        "MOL_FORMULA": "KBr",
        "MOL_MASS": "119.0 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "x",
        "CAS number": null,
        "퍼센트": null,
        "COUNT": 1.0,
        "Unnamed: 13": 1,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "브로민화 칼륨",
        "IUPACNAME": "Potassium Bromide",
        "TRINAME": "Potassium Bromide",
        "LOCATION": "4-4(하)",
        "MOL_FORMULA": "KBr",
        "MOL_MASS": "119.0 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "x",
        "CAS number": null,
        "퍼센트": 1,
        "COUNT": 2.0,
        "Unnamed: 13": 2,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "브로민화 칼륨",
        "IUPACNAME": "Potassium Bromide",
        "TRINAME": "Potassium Bromide",
        "LOCATION": "4-4(하)",
        "MOL_FORMULA": "KBr",
        "MOL_MASS": "119.0 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "x",
        "CAS number": null,
        "퍼센트": "Pike technologies",
        "COUNT": 1.0,
        "Unnamed: 13": 2,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "페리시안화 칼륨",
        "IUPACNAME": "Potassium Ferricyanide",
        "TRINAME": "Potassium Ferricyanide",
        "LOCATION": "4-4(하)",
        "MOL_FORMULA": "K3Fe(CN)6",
        "MOL_MASS": "329.25 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "x",
        "CAS number": null,
        "퍼센트": 0.98,
        "COUNT": 1.0,
        "Unnamed: 13": 5,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "브로민산 칼륨",
        "IUPACNAME": "Potassium Bromate",
        "TRINAME": "Potassium Bromate",
        "LOCATION": "4-4(하)",
        "MOL_FORMULA": "KBrO3",
        "MOL_MASS": "167.01 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": 0.99,
        "COUNT": 1.0,
        "Unnamed: 13": 1,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "수산화 칼륨 용액",
        "IUPACNAME": "Potassium Hydroxide",
        "TRINAME": "Potassium Hydroxide Solution",
        "LOCATION": "4-4(상)",
        "MOL_FORMULA": "KOH",
        "MOL_MASS": "56.11 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": 0.05,
        "COUNT": NaN,
        "Unnamed: 13": 3,
        "Unnamed: 14": null
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Potassium Phosphate monobasic",
        "TRINAME": "Potassium Phosphate monobasic",
        "LOCATION": "4-4(미상)",
        "MOL_FORMULA": "KH2PO4",
        "MOL_MASS": "136.09 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": 0.99,
        "COUNT": NaN,
        "Unnamed: 13": 1,
        "Unnamed: 14": null
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Potassium Ferrocyanide Trihydrate",
        "TRINAME": "Potassium Ferrocyanide",
        "LOCATION": "4-4(하)",
        "MOL_FORMULA": "K4Fe(CN)6 . 3H2O",
        "MOL_MASS": "422.41 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": 0.99,
        "COUNT": NaN,
        "Unnamed: 13": 3,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "과망가니즈산 칼륨",
        "IUPACNAME": "Potassium Permanganate",
        "TRINAME": "Potassium Permanganate",
        "LOCATION": "4-4(하)",
        "MOL_FORMULA": "KMnO4",
        "MOL_MASS": "158.03 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": 0.993,
        "COUNT": NaN,
        "Unnamed: 13": 4,
        "Unnamed: 14": null
    },
    {
        "KORNAME": null,
        "IUPACNAME": null,
        "TRINAME": "점적병",
        "LOCATION": "4-4(하)",
        "MOL_FORMULA": "KMnO4",
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": null,
        "COUNT": NaN,
        "Unnamed: 13": 5,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "펜타놀",
        "IUPACNAME": "n-Amyl alcohol",
        "TRINAME": "Pentanol",
        "LOCATION": "4-4(하)",
        "MOL_FORMULA": "CH3(CH2)4OH",
        "MOL_MASS": "88.15 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": 0.99,
        "COUNT": NaN,
        "Unnamed: 13": 1,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "구연산 칼륨",
        "IUPACNAME": "Potassium Citrate monohydrate",
        "TRINAME": "Potassium Citrate",
        "LOCATION": "4-4(하)",
        "MOL_FORMULA": "K2C6H5O7.H2O",
        "MOL_MASS": "324.42g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": 0,
        "CAS number": "6100-05-06 00:00:00",
        "퍼센트": 0.99,
        "COUNT": NaN,
        "Unnamed: 13": 3,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "탄산 칼륨",
        "IUPACNAME": "potassium Carbonate Anhydrous",
        "TRINAME": "potassium Carbonate",
        "LOCATION": "4-4(하)",
        "MOL_FORMULA": "K2CO3",
        "MOL_MASS": "99.5g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": 0,
        "CAS number": "0584-08-07",
        "퍼센트": 0.995,
        "COUNT": NaN,
        "Unnamed: 13": 1,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "묽은 황산",
        "IUPACNAME": "Sulfuric Acid Solution",
        "TRINAME": "Sulfuric Acid",
        "LOCATION": "4-4(하)",
        "MOL_FORMULA": "H2SO4",
        "MOL_MASS": "98.08g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 2.0,
        "NFPA_B": 3.0,
        "NFPA_W": 0,
        "CAS number": "7664-93-9",
        "퍼센트": null,
        "COUNT": NaN,
        "Unnamed: 13": 1,
        "Unnamed: 14": null
    },
    {
        "KORNAME": "질산제2철 9수화물",
        "IUPACNAME": "Iron(III) Nitrate nonahydrate",
        "TRINAME": null,
        "LOCATION": "5-1 상",
        "MOL_FORMULA": "Fe(NO3)3 9H2O",
        "MOL_MASS": 404.0,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "OX",
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": 2.0
    },
    {
        "KORNAME": "철가루",
        "IUPACNAME": "Iron powder",
        "TRINAME": null,
        "LOCATION": "5-1 상",
        "MOL_FORMULA": "Fe",
        "MOL_MASS": 55.85,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "7439-89-6",
        "퍼센트": NaN,
        "COUNT": 3.0
    },
    {
        "KORNAME": "철 플레이트",
        "IUPACNAME": "Iron plate",
        "TRINAME": null,
        "LOCATION": "5-1 상",
        "MOL_FORMULA": "Fe",
        "MOL_MASS": 55.85,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "7439-89-6",
        "퍼센트": NaN,
        "COUNT": 4.0
    },
    {
        "KORNAME": "산화제2철",
        "IUPACNAME": "Iron(III)oxide,red",
        "TRINAME": "Ferric Oxide",
        "LOCATION": "5-1 상",
        "MOL_FORMULA": "Fe2O3",
        "MOL_MASS": 156.69,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": null,
        "CAS number": "1309-37-1",
        "퍼센트": NaN,
        "COUNT": 2.0
    },
    {
        "KORNAME": "푸마르산",
        "IUPACNAME": "Fumaric acid",
        "TRINAME": null,
        "LOCATION": "5-1 상",
        "MOL_FORMULA": "C4H4O4",
        "MOL_MASS": 116.07,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": null,
        "CAS number": "110-17-8",
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "폼산",
        "IUPACNAME": "Formic acid",
        "TRINAME": null,
        "LOCATION": "5-1 상",
        "MOL_FORMULA": "HCOOH",
        "MOL_MASS": 46.03,
        "NFPA_R": 2.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 3.0,
        "NFPA_W": null,
        "CAS number": "64-18-6",
        "퍼센트": NaN,
        "COUNT": 7.0
    },
    {
        "KORNAME": "펠링용액 B",
        "IUPACNAME": "Fehling solution B",
        "TRINAME": null,
        "LOCATION": "5-1 상",
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "1310-73-2",
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "염화제2철 6수화물",
        "IUPACNAME": "Ferric chloride",
        "TRINAME": "Iron(III) Chloride Hexahydrate",
        "LOCATION": "5-1 상",
        "MOL_FORMULA": "FeCl3 6H2O",
        "MOL_MASS": 270.3,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": null,
        "CAS number": "7705-08-0",
        "퍼센트": NaN,
        "COUNT": 3.0
    },
    {
        "KORNAME": "황산제2철 n수화물",
        "IUPACNAME": "Iron(III) sulfate n-hydrate",
        "TRINAME": null,
        "LOCATION": "5-1 상",
        "MOL_FORMULA": "Fe2(SO4)3 nH2O",
        "MOL_MASS": NaN,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "15244-10-7",
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "폼알데하이드 용액",
        "IUPACNAME": "Fomaldehyde solution",
        "TRINAME": null,
        "LOCATION": "5-1 상",
        "MOL_FORMULA": "HCHO",
        "MOL_MASS": 30.03,
        "NFPA_R": 4.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 3.0,
        "NFPA_W": "COR",
        "CAS number": "50-00-0",
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "펠링용액 A",
        "IUPACNAME": "Fehling solution A",
        "TRINAME": null,
        "LOCATION": "5-1 상",
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "7758-99-8",
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "아이소아밀 알코올",
        "IUPACNAME": "Isoamyl alcohol",
        "TRINAME": null,
        "LOCATION": "5-1 상",
        "MOL_FORMULA": "(CH3)2CHCH2CH2OH",
        "MOL_MASS": 88.15,
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "123-51-3",
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "황산제1철 7수화물",
        "IUPACNAME": "Iron(II) sulfate heptahydrate",
        "TRINAME": null,
        "LOCATION": "5-1 상",
        "MOL_FORMULA": "FeSO4 7H2O",
        "MOL_MASS": 278.02,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "7782-63-0",
        "퍼센트": NaN,
        "COUNT": 2.0
    },
    {
        "KORNAME": "1, 4 다이옥세인",
        "IUPACNAME": "1, 4 dioxane",
        "TRINAME": null,
        "LOCATION": "5-1 상",
        "MOL_FORMULA": "C4H8O2",
        "MOL_MASS": 88.11,
        "NFPA_R": 3.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": null,
        "CAS number": "123-91-1",
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "황산제이구리 5수화물",
        "IUPACNAME": "Copper(II) Sulfate pentahydrate",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": "CuSO4 * 5H2O",
        "MOL_MASS": 249.568,
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "7758-99-8",
        "퍼센트": NaN,
        "COUNT": 2.0
    },
    {
        "KORNAME": "주석 가루",
        "IUPACNAME": "Tin Powder",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": "Sn",
        "MOL_MASS": 118.7,
        "NFPA_R": 2.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "7440-31-5",
        "퍼센트": NaN,
        "COUNT": 3.0
    },
    {
        "KORNAME": "니켈 알갱이",
        "IUPACNAME": "Nickel granular(NI)",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": "Ni",
        "MOL_MASS": 58.6934,
        "NFPA_R": 2.0,
        "NFPA_Y": 4.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": "7440-02-0",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "납조각",
        "IUPACNAME": "Lead Plate",
        "TRINAME": null,
        "LOCATION": "5-1 하 ",
        "MOL_FORMULA": "Pb",
        "MOL_MASS": 207.2,
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": null,
        "CAS number": "7439-92-1",
        "퍼센트": NaN,
        "COUNT": 3.0
    },
    {
        "KORNAME": "대리석",
        "IUPACNAME": null,
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": "471-34-1",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "펜테인",
        "IUPACNAME": "n-Pentane",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": "CH3(CH2)3CH3",
        "MOL_MASS": 72.15,
        "NFPA_R": 1.0,
        "NFPA_Y": 4.0,
        "NFPA_B": 0.0,
        "NFPA_W": null,
        "CAS number": "109-66-0",
        "퍼센트": NaN,
        "COUNT": 3.0
    },
    {
        "KORNAME": "아연 조각",
        "IUPACNAME": "Zinc plate",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": "Zn",
        "MOL_MASS": 65.8,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": null,
        "CAS number": "7440-66-6",
        "퍼센트": NaN,
        "COUNT": 8.0
    },
    {
        "KORNAME": "아연",
        "IUPACNAME": "Zinc ",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": "Zn",
        "MOL_MASS": 65.8,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": null,
        "CAS number": "7440-66-6",
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "황산아연 7수화물",
        "IUPACNAME": "Zinc Sulfate Heptahydrate",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": "ZnSO4 *7H2O",
        "MOL_MASS": 287.56,
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "아연 가루",
        "IUPACNAME": "Zinc Powder",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": "Zn",
        "MOL_MASS": 65.8,
        "NFPA_R": 3.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": 2.0
    },
    {
        "KORNAME": "주석 탄",
        "IUPACNAME": "Tin, shot",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": "Sn",
        "MOL_MASS": 118.69,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "베네딕트 용액",
        "IUPACNAME": "Benedic Solution",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": null,
        "MOL_MASS": NaN,
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "주석",
        "IUPACNAME": "Tin ",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": "Sn",
        "MOL_MASS": 118.7,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산 스트론튬",
        "IUPACNAME": "Strontium Nitrate",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": "Sr(NO3)2",
        "MOL_MASS": 211.63,
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "OX",
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "질산스트론튬 무수화물",
        "IUPACNAME": "strontium nitrate,anhydrous",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": "Sr(NO3)2",
        "MOL_MASS": 211.63,
        "NFPA_R": 2.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": "OX",
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "니켈 플레이트",
        "IUPACNAME": "Nickel plate",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": "Ni",
        "MOL_MASS": 58.7,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": 1.0
    },
    {
        "KORNAME": "질산은용액",
        "IUPACNAME": "0.05N-Silver(I) nitrate standard solution",
        "TRINAME": null,
        "LOCATION": "5-1 하",
        "MOL_FORMULA": "AgNO3",
        "MOL_MASS": 169.87,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN
    },
    {
        "KORNAME": "황산 칼륨",
        "IUPACNAME": "Potassium Sulfate",
        "TRINAME": NaN,
        "LOCATION": "5-2하",
        "MOL_FORMULA": "K2SO4",
        "MOL_MASS": "174.26 g/mol",
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 7
    },
    {
        "KORNAME": "수산화 칼륨",
        "IUPACNAME": "Potassium Hydroxide",
        "TRINAME": NaN,
        "LOCATION": "5-2하",
        "MOL_FORMULA": "KOH",
        "MOL_MASS": "56.11 g/mol",
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 3.0,
        "NFPA_W": "ALK",
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 2
    },
    {
        "KORNAME": "글루코스",
        "IUPACNAME": "Glucose",
        "TRINAME": NaN,
        "LOCATION": "5-2하",
        "MOL_FORMULA": "C612O6",
        "MOL_MASS": "180.16 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 0.0,
        "NFPA_W": null,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 2
    },
    {
        "KORNAME": "벤진",
        "IUPACNAME": "Petroleum ether",
        "TRINAME": NaN,
        "LOCATION": "5-2하",
        "MOL_FORMULA": null,
        "MOL_MASS": "82.2 g/mol",
        "NFPA_R": 4.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": null,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 3
    },
    {
        "KORNAME": "옥살산칼륨 일수화물",
        "IUPACNAME": "Potassium Oxalate, Monohydrate",
        "TRINAME": NaN,
        "LOCATION": "5-2하",
        "MOL_FORMULA": "K2C2O4•H2O",
        "MOL_MASS": "184.23 g/mol",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": null,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Starch Soluble",
        "TRINAME": NaN,
        "LOCATION": null,
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Potassium iodate",
        "TRINAME": NaN,
        "LOCATION": "5-2하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": NaN,
        "퍼센트": NaN,
        "COUNT": 1
    },
    {
        "KORNAME": "알루미늄 판",
        "IUPACNAME": "Aluminum",
        "TRINAME": "Aluminum Plate",
        "LOCATION": "5-3 상",
        "MOL_FORMULA": "Al",
        "MOL_MASS": 26.98,
        "NFPA_R": 1.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 0.0,
        "NFPA_W": "-",
        "CAS number": "7429-90-5",
        "퍼센트": "-",
        "COUNT": 5.0
    },
    {
        "KORNAME": "비스무트, ",
        "IUPACNAME": "Bismuth",
        "TRINAME": "Bismuth, Shot",
        "LOCATION": "5-3 상",
        "MOL_FORMULA": "Bi",
        "MOL_MASS": 208.98,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "7440-69-9",
        "퍼센트": "-",
        "COUNT": 1.0
    },
    {
        "KORNAME": "구리 판",
        "IUPACNAME": "Copper",
        "TRINAME": "Cupric Plate",
        "LOCATION": "5-3 상",
        "MOL_FORMULA": "Cu",
        "MOL_MASS": 63.55,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "7440-50-8",
        "퍼센트": "-",
        "COUNT": 4.0
    },
    {
        "KORNAME": "구리 분말",
        "IUPACNAME": "Copper",
        "TRINAME": "Copper, powder",
        "LOCATION": "5-3 상",
        "MOL_FORMULA": "Cu",
        "MOL_MASS": 63.55,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "7440-50-8",
        "퍼센트": 99.85,
        "COUNT": 1.0
    },
    {
        "KORNAME": "산화 구리(II)",
        "IUPACNAME": "Copper(II) oxide",
        "TRINAME": "Cupric oxide",
        "LOCATION": "5-3 상",
        "MOL_FORMULA": "CuO",
        "MOL_MASS": 79.55,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "1317-38-0",
        "퍼센트": 95,
        "COUNT": 1.0
    },
    {
        "KORNAME": "에틸렌 글라이콜",
        "IUPACNAME": "Ethane-1,2-diol",
        "TRINAME": "Ethylene glycol",
        "LOCATION": "5-3 상",
        "MOL_FORMULA": "C2H6O2",
        "MOL_MASS": 62.07,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": "-",
        "CAS number": "107-21-1",
        "퍼센트": 99,
        "COUNT": 2.0
    },
    {
        "KORNAME": "젤라틴",
        "IUPACNAME": "Gelatin",
        "TRINAME": "Gelatin",
        "LOCATION": "5-3 상",
        "MOL_FORMULA": "(C66H104N18O18)n",
        "MOL_MASS": "-",
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "9000-70-8",
        "퍼센트": "-",
        "COUNT": 2.0
    },
    {
        "KORNAME": null,
        "IUPACNAME": null,
        "TRINAME": null,
        "LOCATION": null,
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": NaN,
        "NFPA_Y": NaN,
        "NFPA_B": NaN,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": null,
        "COUNT": NaN
    },
    {
        "KORNAME": null,
        "IUPACNAME": "(1S)-(-)-2,6,6-Trimethylbicyclo[3.1.1]hept-2-ene",
        "TRINAME": "(1S)-(-)-β-Pinene",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "C10H16",
        "MOL_MASS": 136.24,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "7785-70-8",
        "퍼센트": 99,
        "COUNT": 1.0
    },
    {
        "KORNAME": "L(+)-아스코르브산",
        "IUPACNAME": "(R)-2-(3,4-dihydroxyphenyl)-1,2,3,4-tetrahydroxybutan-1-one",
        "TRINAME": "L(+)-Ascorbic acid",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "C6H8O6",
        "MOL_MASS": 176.12,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "50-81-7",
        "퍼센트": "-",
        "COUNT": 2.0
    },
    {
        "KORNAME": "L(+)-아스코르브산",
        "IUPACNAME": "(R)-2-(3,4-dihydroxyphenyl)-1,2,3,4-tetrahydroxybutan-1-one",
        "TRINAME": "L(+)-Ascorbic acid",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "C6H8O6",
        "MOL_MASS": 176.12,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "50-81-7",
        "퍼센트": 99,
        "COUNT": 2.0
    },
    {
        "KORNAME": "L(+)-아스코르브산",
        "IUPACNAME": "(R)-2-(3,4-dihydroxyphenyl)-1,2,3,4-tetrahydroxybutan-1-one",
        "TRINAME": "L(+)-Ascorbic acid",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "C6H8O6",
        "MOL_MASS": 176.12,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "50-81-7",
        "퍼센트": 99.5,
        "COUNT": 4.0
    },
    {
        "KORNAME": "3,5-디니트로살리실산",
        "IUPACNAME": "2-Hydroxy-3,5-dinitrobenzoic acid",
        "TRINAME": "3,5-Dinitrosalicylic acid",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "C7H6N2O5",
        "MOL_MASS": 214.14,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": "-",
        "CAS number": "606-20-2",
        "퍼센트": 97,
        "COUNT": 1.0
    },
    {
        "KORNAME": "쿠마린",
        "IUPACNAME": "2H-Chromen-2-one",
        "TRINAME": "Coumarin",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "C9H6O2",
        "MOL_MASS": 146.15,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "91-64-5",
        "퍼센트": 99,
        "COUNT": 1.0
    },
    {
        "KORNAME": "루미놀",
        "IUPACNAME": "5-Amino-2,3-dihydro-1,4-phthalazinedione",
        "TRINAME": "Luminol",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "C8H7N3O2",
        "MOL_MASS": 179.17,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "521-31-3",
        "퍼센트": "-",
        "COUNT": 1.0
    },
    {
        "KORNAME": "인산암모늄 단일염",
        "IUPACNAME": "Ammonium dihydrogen phosphate",
        "TRINAME": "Ammonium Phosphate monobasic",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "NH4H2PO4",
        "MOL_MASS": 115.03,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "7722-76-1",
        "퍼센트": 98,
        "COUNT": 3.0
    },
    {
        "KORNAME": "황산 암모늄",
        "IUPACNAME": "Ammonium sulfamate",
        "TRINAME": "Ammonium sulphamate",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "NH4SO3NH2",
        "MOL_MASS": 116.14,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "7773-06-0",
        "퍼센트": 98.5,
        "COUNT": 1.0
    },
    {
        "KORNAME": "셀룰레이스",
        "IUPACNAME": "Cellulase",
        "TRINAME": "Cellulase",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "-",
        "MOL_MASS": "-",
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "9012-54-8",
        "퍼센트": "-",
        "COUNT": 1.0
    },
    {
        "KORNAME": "무수 에틸렌디아민",
        "IUPACNAME": "Ethanediamine",
        "TRINAME": "Ethylenediamine, anhydrous",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "C2H8N2",
        "MOL_MASS": 60.1,
        "NFPA_R": 3.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 3.0,
        "NFPA_W": "-",
        "CAS number": "107-15-3",
        "퍼센트": 98,
        "COUNT": 1.0
    },
    {
        "KORNAME": "팔미트산",
        "IUPACNAME": "Hexadecanoic acid",
        "TRINAME": "Palmitic acid",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "C16H32O2",
        "MOL_MASS": 256.42,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "57-10-3",
        "퍼센트": 95,
        "COUNT": 1.0
    },
    {
        "KORNAME": "염화철(III) 육수화물",
        "IUPACNAME": "Iron(III) chloride hexahydrate",
        "TRINAME": "Iron trichloride hexahydrate",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "FeCl3·6H2O",
        "MOL_MASS": 270.3,
        "NFPA_R": 0.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 2.0,
        "NFPA_W": "-",
        "CAS number": "10025-77-1",
        "퍼센트": 97,
        "COUNT": 1.0
    },
    {
        "KORNAME": "에리오크롬 블랙 T",
        "IUPACNAME": "Sodium 2-(2-hydroxy-1-naphthylazo)-1-naphthol-3,6-disulfonate",
        "TRINAME": "Eriochrome Black T",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "C20H12N3NaO7S",
        "MOL_MASS": 461.38,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "1863-26-1",
        "퍼센트": "-",
        "COUNT": 1.0
    },
    {
        "KORNAME": "황 분말",
        "IUPACNAME": "Sulfur",
        "TRINAME": "Sulfer Powder",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "S",
        "MOL_MASS": 32.07,
        "NFPA_R": 1.0,
        "NFPA_Y": 0.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "7704-34-9",
        "퍼센트": "-",
        "COUNT": 1.0
    },
    {
        "KORNAME": "2-운데카논",
        "IUPACNAME": "Undecan-2-one",
        "TRINAME": "2-undecanone",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "C11H22O",
        "MOL_MASS": 170.29,
        "NFPA_R": 1.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 1.0,
        "NFPA_W": "-",
        "CAS number": "112-12-9",
        "퍼센트": 99,
        "COUNT": 1.0
    },
    {
        "KORNAME": "염화 아연",
        "IUPACNAME": "Zinc chloride",
        "TRINAME": "Zinc(II) chloride",
        "LOCATION": "5-3 하",
        "MOL_FORMULA": "ZnCl2",
        "MOL_MASS": 136.3,
        "NFPA_R": 0.0,
        "NFPA_Y": 1.0,
        "NFPA_B": 2.0,
        "NFPA_W": "-",
        "CAS number": "7646-85-7",
        "퍼센트": 98,
        "COUNT": 1.0
    },
    {
        "KORNAME": "L-트레오닌",
        "IUPACNAME": "L-Threonine",
        "TRINAME": null,
        "LOCATION": "5-4하",
        "MOL_FORMULA": "C4H9NO3",
        "MOL_MASS": 119.12,
        "NFPA_R": "-",
        "NFPA_Y": "-",
        "NFPA_B": "-",
        "NFPA_W": "-",
        "CAS number": "72-19-5",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": "INSERT INTO reagent (KORNAME, IUPACNAME, TRINAME, LOCATION, MOL_FORMULA, MOL_MASS, NFPA_R, NFPA_Y, NFPA_B, NFPA_W, CAS_number, percent, COUNT, location_room) VALUES ('L-트레오닌', 'L-Threonine', NULL, '5-4하', 'C4H9NO3', 119.12, NULL, NULL, NULL, NULL, '72-19-5', NULL, NULL, '화학')"
    },
    {
        "KORNAME": "다이메틸 설폭사이드",
        "IUPACNAME": "Dimethyl Sulfoxide",
        "TRINAME": null,
        "LOCATION": "5-4하",
        "MOL_FORMULA": "C2H6OS",
        "MOL_MASS": 78.13,
        "NFPA_R": 2,
        "NFPA_Y": 0,
        "NFPA_B": 1,
        "NFPA_W": "-",
        "CAS number": "67-68-5",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('다이메틸 설폭사이드', 'Dimethyl Sulfoxide', NULL, '5-4하', 'C2H6OS', 78.13, 2, 0, 1, NULL, '67-68-5', NULL, NULL, '화학')"
    },
    {
        "KORNAME": " 염소산 칼륨",
        "IUPACNAME": "Potassium Iodate",
        "TRINAME": null,
        "LOCATION": "5-4상",
        "MOL_FORMULA": "KClO3",
        "MOL_MASS": 122.55,
        "NFPA_R": 0,
        "NFPA_Y": 2,
        "NFPA_B": 3,
        "NFPA_W": "OX",
        "CAS number": "3811-04-09 00:00:00",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", (' 염소산 칼륨', 'Potassium Iodate', NULL, '5-4상', 'KClO3', 122.55, 0, 2, 3, 'OX', '698078', NULL, NULL, '화학')"
    },
    {
        "KORNAME": "질산 칼륨",
        "IUPACNAME": "Potassium Nitrate",
        "TRINAME": null,
        "LOCATION": "5-4상",
        "MOL_FORMULA": "KNO3",
        "MOL_MASS": 101.1032,
        "NFPA_R": 0,
        "NFPA_Y": 1,
        "NFPA_B": 0,
        "NFPA_W": "OX",
        "CAS number": "7757-79-1",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('질산 칼륨', 'Potassium Nitrate', NULL, '5-4상', 'KNO3', 101.1032, 0, 1, 0, 'OX', '7757-79-1', NULL, NULL, '화학')"
    },
    {
        "KORNAME": "질산 칼륨",
        "IUPACNAME": "Potassium Nitrate",
        "TRINAME": null,
        "LOCATION": "5-4상",
        "MOL_FORMULA": "KNO3",
        "MOL_MASS": 101.1032,
        "NFPA_R": 0,
        "NFPA_Y": 1,
        "NFPA_B": 0,
        "NFPA_W": "OX",
        "CAS number": "7757-79-1",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('질산 칼륨', 'Potassium Nitrate', NULL, '5-4상', 'KNO3', 101.1032, 0, 1, 0, 'OX', '7757-79-1', NULL, NULL, '화학')"
    },
    {
        "KORNAME": "폴리 바이닐 알코올",
        "IUPACNAME": "Polyvinyl Alcohol",
        "TRINAME": null,
        "LOCATION": "5-4하",
        "MOL_FORMULA": "(C2H4O)x",
        "MOL_MASS": "-",
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 0,
        "NFPA_W": "-",
        "CAS number": "9002-89-5",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('폴리 바이닐 알코올', 'Polyvinyl Alcohol', NULL, '5-4하', '(C2H4O)x', NULL, 1, 0, 0, NULL, '9002-89-5', NULL, NULL, '화학')"
    },
    {
        "KORNAME": "폴리 에틸렌 글라이콜",
        "IUPACNAME": "Polyethylene glycol #6000",
        "TRINAME": null,
        "LOCATION": "5-4하",
        "MOL_FORMULA": "(C2H4O)nH2O",
        "MOL_MASS": "-",
        "NFPA_R": 1,
        "NFPA_Y": 2,
        "NFPA_B": 0,
        "NFPA_W": "-",
        "CAS number": "25322-68-3",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('폴리 에틸렌 글라이콜', 'Polyethylene glycol #6000', NULL, '5-4하', '(C2H4O)nH2O', NULL, 1, 2, 0, NULL, '25322-68-3', NULL, NULL, '화학')"
    },
    {
        "KORNAME": "L-트레오닌",
        "IUPACNAME": "L-Threonine",
        "TRINAME": null,
        "LOCATION": "5-4하",
        "MOL_FORMULA": "C4H9NO3",
        "MOL_MASS": 119.12,
        "NFPA_R": "-",
        "NFPA_Y": "-",
        "NFPA_B": "-",
        "NFPA_W": "-",
        "CAS number": "72-19-5",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('L-트레오닌', 'L-Threonine', NULL, '5-4하', 'C4H9NO3', 119.12, NULL, NULL, NULL, NULL, '72-19-5', NULL, NULL, '화학')"
    },
    {
        "KORNAME": "폴리 바이닐 알코올",
        "IUPACNAME": "Polyvinyl Alcohol",
        "TRINAME": null,
        "LOCATION": "5-4하",
        "MOL_FORMULA": "(C2H4O)x",
        "MOL_MASS": "-",
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 0,
        "NFPA_W": "-",
        "CAS number": "9002-89-5",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('폴리 바이닐 알코올', 'Polyvinyl Alcohol', NULL, '5-4하', '(C2H4O)x', NULL, 1, 0, 0, NULL, '9002-89-5', NULL, NULL, '화학')"
    },
    {
        "KORNAME": "바이페닐 케토스",
        "IUPACNAME": "diphenyl kentose",
        "TRINAME": null,
        "LOCATION": "5-4하",
        "MOL_FORMULA": "-",
        "MOL_MASS": "-",
        "NFPA_R": "-",
        "NFPA_Y": "-",
        "NFPA_B": "-",
        "NFPA_W": "-",
        "CAS number": "-",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('바이페닐 케토스', 'diphenyl kentose', NULL, '5-4하', NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, '화학')"
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Molecular sieves, 4A",
        "TRINAME": null,
        "LOCATION": "5-4하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": null,
        "NFPA_Y": null,
        "NFPA_B": null,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", (NULL, 'Molecular sieves, 4A', NULL, '5-4하', NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, '화학')"
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Poly(maleic anhydride-alt-1-octadecene)",
        "TRINAME": null,
        "LOCATION": "5-4하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": null,
        "NFPA_Y": null,
        "NFPA_B": null,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", (NULL, 'Poly(maleic anhydride-alt-1-octadecene)', NULL, '5-4하', NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, '화학')"
    },
    {
        "KORNAME": "폴리비닐피롤리돈",
        "IUPACNAME": "Polyvinylpyrrolidone K-30",
        "TRINAME": "PVP",
        "LOCATION": "5-4하",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": null,
        "NFPA_Y": null,
        "NFPA_B": null,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('폴리비닐피롤리돈', 'Polyvinylpyrrolidone K-30', 'PVP', '5-4하', NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, '화학')"
    },
    {
        "KORNAME": "폴리바이닐 알코올",
        "IUPACNAME": "Polyvinyl Alcohol",
        "TRINAME": "PVA",
        "LOCATION": "5-4하",
        "MOL_FORMULA": "(C2H4O)x",
        "MOL_MASS": "-",
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 0,
        "NFPA_W": "-",
        "CAS number": "9002-89-5",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('폴리바이닐 알코올', 'Polyvinyl Alcohol', 'PVA', '5-4하', '(C2H4O)x', NULL, 1, 0, 0, NULL, '9002-89-5', NULL, NULL, '화학')"
    },
    {
        "KORNAME": "폴리바이닐 알코올",
        "IUPACNAME": "Polyvinyl Alcohol",
        "TRINAME": "PVA",
        "LOCATION": "5-4하",
        "MOL_FORMULA": "(C2H4O)x",
        "MOL_MASS": "-",
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 0,
        "NFPA_W": "-",
        "CAS number": "9002-89-5",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('폴리바이닐 알코올', 'Polyvinyl Alcohol', 'PVA', '5-4하', '(C2H4O)x', NULL, 1, 0, 0, NULL, '9002-89-5', NULL, NULL, '화학')"
    },
    {
        "KORNAME": "한천가루",
        "IUPACNAME": "Agar powder",
        "TRINAME": null,
        "LOCATION": "5-4상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": null,
        "NFPA_Y": null,
        "NFPA_B": null,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('한천가루', 'Agar powder', NULL, '5-4상', NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, '화학')"
    },
    {
        "KORNAME": "다이클로로메테인",
        "IUPACNAME": "Dichloromethane",
        "TRINAME": null,
        "LOCATION": "5-4하",
        "MOL_FORMULA": "CH2Cl2",
        "MOL_MASS": 84.93,
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "-",
        "CAS number": "1975-09-02 00:00:00",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('다이클로로메테인', 'Dichloromethane', NULL, '5-4하', 'CH2Cl2', 84.93, 1, 0, 2, NULL, '27639', NULL, NULL, '화학')"
    },
    {
        "KORNAME": "다이클로로메테인",
        "IUPACNAME": "Dichloromethane",
        "TRINAME": null,
        "LOCATION": "5-4하",
        "MOL_FORMULA": "CH2Cl2",
        "MOL_MASS": 84.93,
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "-",
        "CAS number": "1975-09-02 00:00:00",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('다이클로로메테인', 'Dichloromethane', NULL, '5-4하', 'CH2Cl2', 84.93, 1, 0, 2, NULL, '27639', NULL, NULL, '화학')"
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Potassium Iodate",
        "TRINAME": null,
        "LOCATION": "5-4상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": null,
        "NFPA_Y": null,
        "NFPA_B": null,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", (NULL, 'Potassium Iodate', NULL, '5-4상', NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, '화학')"
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Potassium Iodate",
        "TRINAME": null,
        "LOCATION": "5-4상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": null,
        "NFPA_Y": null,
        "NFPA_B": null,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", (NULL, 'Potassium Iodate', NULL, '5-4상', NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, '화학')"
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Potassium Iodate",
        "TRINAME": null,
        "LOCATION": "5-4상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": null,
        "NFPA_Y": null,
        "NFPA_B": null,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", (NULL, 'Potassium Iodate', NULL, '5-4상', NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, '화학')"
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Potassium Iodate",
        "TRINAME": null,
        "LOCATION": "5-4상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": null,
        "NFPA_Y": null,
        "NFPA_B": null,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", (NULL, 'Potassium Iodate', NULL, '5-4상', NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, '화학')"
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Potassium Iodate",
        "TRINAME": null,
        "LOCATION": "5-4상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": null,
        "NFPA_Y": null,
        "NFPA_B": null,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", (NULL, 'Potassium Iodate', NULL, '5-4상', NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, '화학')"
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Potassium Iodate",
        "TRINAME": null,
        "LOCATION": "5-4상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": null,
        "NFPA_Y": null,
        "NFPA_B": null,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", (NULL, 'Potassium Iodate', NULL, '5-4상', NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, '화학')"
    },
    {
        "KORNAME": "L-트레오닌",
        "IUPACNAME": "L-Threonine",
        "TRINAME": null,
        "LOCATION": "5-4하",
        "MOL_FORMULA": "C4H9NO3",
        "MOL_MASS": 119.12,
        "NFPA_R": "-",
        "NFPA_Y": "-",
        "NFPA_B": "-",
        "NFPA_W": "-",
        "CAS number": "72-19-5",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('L-트레오닌', 'L-Threonine', NULL, '5-4하', 'C4H9NO3', 119.12, NULL, NULL, NULL, NULL, '72-19-5', NULL, NULL, '화학')"
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Potassium Iodate",
        "TRINAME": null,
        "LOCATION": "5-4상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": null,
        "NFPA_Y": null,
        "NFPA_B": null,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", (NULL, 'Potassium Iodate', NULL, '5-4상', NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, '화학')"
    },
    {
        "KORNAME": "다이클로로메테인",
        "IUPACNAME": "Dichloromethane",
        "TRINAME": null,
        "LOCATION": "5-4하",
        "MOL_FORMULA": "CH2Cl2",
        "MOL_MASS": 84.93,
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "-",
        "CAS number": "1975-09-02 00:00:00",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('다이클로로메테인', 'Dichloromethane', NULL, '5-4하', 'CH2Cl2', 84.93, 1, 0, 2, NULL, '27639', NULL, NULL, '화학')"
    },
    {
        "KORNAME": "다이클로로메테인",
        "IUPACNAME": "Dichloromethane",
        "TRINAME": null,
        "LOCATION": "5-4하",
        "MOL_FORMULA": "CH2Cl2",
        "MOL_MASS": 84.93,
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 2,
        "NFPA_W": "-",
        "CAS number": "1975-09-02 00:00:00",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('다이클로로메테인', 'Dichloromethane', NULL, '5-4하', 'CH2Cl2', 84.93, 1, 0, 2, NULL, '27639', NULL, NULL, '화학')"
    },
    {
        "KORNAME": null,
        "IUPACNAME": "Potassium Hydrogentartrate",
        "TRINAME": null,
        "LOCATION": "5-4상",
        "MOL_FORMULA": null,
        "MOL_MASS": null,
        "NFPA_R": null,
        "NFPA_Y": null,
        "NFPA_B": null,
        "NFPA_W": null,
        "CAS number": null,
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", (NULL, 'Potassium Hydrogentartrate', NULL, '5-4상', NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, NULL, '화학')"
    },
    {
        "KORNAME": "포도당",
        "IUPACNAME": "Dextrose",
        "TRINAME": "glucose",
        "LOCATION": "5-4하",
        "MOL_FORMULA": "C6H12O6",
        "MOL_MASS": 180.156,
        "NFPA_R": 1,
        "NFPA_Y": 0,
        "NFPA_B": 0,
        "NFPA_W": "-",
        "CAS number": "50-99-7",
        "퍼센트": NaN,
        "COUNT": NaN,
        "Unnamed: 13": ", ('포도당', 'Dextrose', 'glucose', '5-4하', 'C6H12O6', 180.156, 1, 0, 0, NULL, '50-99-7', NULL, NULL, '화학')"
    }
];